import imagem_cpfl_paulista from '../imgs/cpfl_paulista.png'
import cpfl_piratininga from '../imgs/cpfl_piratininga.png'
import enel_ceara from '../imgs/enel_ceara.png'
import enel_rio_janeiro from '../imgs/enel_ceara.png'
import cpfl_santa_cruz from '../imgs/cpfl_santa_cruz.png'
import enel_sao_paulo from '../imgs/enel_sao_paulo.png'
import rge from '../imgs/rge.png'
import rge_sul from '../imgs/rge_sul.png'
import cosern from '../imgs/cosern.png'
import celpe from '../imgs/celpe.png'

export default function imagemContaLuz(uf, municipio){
    if (uf != null && municipio != null){
        uf = uf.toLowerCase();
        municipio = municipio.toLowerCase();
    }

    if (uf == "ce" && municipio == "abaiara"){ return enel_ceara }
    if (uf == "ce" && municipio == "acarape"){ return enel_ceara }
    if (uf == "ce" && municipio == "acarau"){ return enel_ceara }
    if (uf == "ce" && municipio == "acopiara"){ return enel_ceara }
    if (uf == "ce" && municipio == "aiuaba"){ return enel_ceara }
    if (uf == "ce" && municipio == "alcantaras"){ return enel_ceara }
    if (uf == "ce" && municipio == "altaneira"){ return enel_ceara }
    if (uf == "ce" && municipio == "alto santo"){ return enel_ceara }
    if (uf == "ce" && municipio == "amontada"){ return enel_ceara }
    if (uf == "ce" && municipio == "antonina do norte"){ return enel_ceara }
    if (uf == "ce" && municipio == "apuiares"){ return enel_ceara }
    if (uf == "ce" && municipio == "aquiraz"){ return enel_ceara }
    if (uf == "ce" && municipio == "aracati"){ return enel_ceara }
    if (uf == "ce" && municipio == "aracatiacu"){ return enel_ceara }
    if (uf == "ce" && municipio == "aracoiaba"){ return enel_ceara }
    if (uf == "ce" && municipio == "ararenda"){ return enel_ceara }
    if (uf == "ce" && municipio == "araripe"){ return enel_ceara }
    if (uf == "ce" && municipio == "aratuba"){ return enel_ceara }
    if (uf == "ce" && municipio == "arneiroz"){ return enel_ceara }
    if (uf == "ce" && municipio == "assare"){ return enel_ceara }
    if (uf == "ce" && municipio == "aurora"){ return enel_ceara }
    if (uf == "ce" && municipio == "baixio"){ return enel_ceara }
    if (uf == "ce" && municipio == "banabuiu"){ return enel_ceara }
    if (uf == "ce" && municipio == "barbalha"){ return enel_ceara }
    if (uf == "ce" && municipio == "barreira"){ return enel_ceara }
    if (uf == "ce" && municipio == "barro"){ return enel_ceara }
    if (uf == "ce" && municipio == "barroquinha"){ return enel_ceara }
    if (uf == "ce" && municipio == "baturite"){ return enel_ceara }
    if (uf == "ce" && municipio == "beberibe"){ return enel_ceara }
    if (uf == "ce" && municipio == "bela cruz"){ return enel_ceara }
    if (uf == "ce" && municipio == "boa viagem"){ return enel_ceara }
    if (uf == "ce" && municipio == "brejo santo"){ return enel_ceara }
    if (uf == "ce" && municipio == "camocim"){ return enel_ceara }
    if (uf == "ce" && municipio == "campos sales"){ return enel_ceara }
    if (uf == "ce" && municipio == "caninde"){ return enel_ceara }
    if (uf == "ce" && municipio == "capistrano"){ return enel_ceara }
    if (uf == "ce" && municipio == "caridade"){ return enel_ceara }
    if (uf == "ce" && municipio == "carire"){ return enel_ceara }
    if (uf == "ce" && municipio == "caririacu"){ return enel_ceara }
    if (uf == "ce" && municipio == "carius"){ return enel_ceara }
    if (uf == "ce" && municipio == "carnaubal"){ return enel_ceara }
    if (uf == "ce" && municipio == "cascavel"){ return enel_ceara }
    if (uf == "ce" && municipio == "catarina"){ return enel_ceara }
    if (uf == "ce" && municipio == "catunda"){ return enel_ceara }
    if (uf == "ce" && municipio == "caucaia"){ return enel_ceara }
    if (uf == "ce" && municipio == "cedro"){ return enel_ceara }
    if (uf == "ce" && municipio == "chaval"){ return enel_ceara }
    if (uf == "ce" && municipio == "choro"){ return enel_ceara }
    if (uf == "ce" && municipio == "chorozinho"){ return enel_ceara }
    if (uf == "ce" && municipio == "coreau"){ return enel_ceara }
    if (uf == "ce" && municipio == "crateus"){ return enel_ceara }
    if (uf == "ce" && municipio == "crato"){ return enel_ceara }
    if (uf == "ce" && municipio == "croata"){ return enel_ceara }
    if (uf == "ce" && municipio == "cruz"){ return enel_ceara }
    if (uf == "ce" && municipio == "deputado irapuan pinheiro"){ return enel_ceara }
    if (uf == "ce" && municipio == "erere"){ return enel_ceara }
    if (uf == "ce" && municipio == "eusebio"){ return enel_ceara }
    if (uf == "ce" && municipio == "farias brito"){ return enel_ceara }
    if (uf == "ce" && municipio == "forquilha"){ return enel_ceara }
    if (uf == "ce" && municipio == "fortaleza"){ return enel_ceara }
    if (uf == "ce" && municipio == "fortim"){ return enel_ceara }
    if (uf == "ce" && municipio == "frecheirinha"){ return enel_ceara }
    if (uf == "ce" && municipio == "general sampaio"){ return enel_ceara }
    if (uf == "ce" && municipio == "graca"){ return enel_ceara }
    if (uf == "ce" && municipio == "granja"){ return enel_ceara }
    if (uf == "ce" && municipio == "granjeiro"){ return enel_ceara }
    if (uf == "ce" && municipio == "groairas"){ return enel_ceara }
    if (uf == "ce" && municipio == "guaiuba"){ return enel_ceara }
    if (uf == "ce" && municipio == "guaraciaba do norte"){ return enel_ceara }
    if (uf == "ce" && municipio == "guaramiranga"){ return enel_ceara }
    if (uf == "ce" && municipio == "hidrolandia"){ return enel_ceara }
    if (uf == "ce" && municipio == "horizonte"){ return enel_ceara }
    if (uf == "ce" && municipio == "ibaretama"){ return enel_ceara }
    if (uf == "ce" && municipio == "ibiapina"){ return enel_ceara }
    if (uf == "ce" && municipio == "ibicuitinga"){ return enel_ceara }
    if (uf == "ce" && municipio == "icapui"){ return enel_ceara }
    if (uf == "ce" && municipio == "ico"){ return enel_ceara }
    if (uf == "ce" && municipio == "iguatu"){ return enel_ceara }
    if (uf == "ce" && municipio == "independencia"){ return enel_ceara }
    if (uf == "ce" && municipio == "ipaporanga"){ return enel_ceara }
    if (uf == "ce" && municipio == "ipaumirim"){ return enel_ceara }
    if (uf == "ce" && municipio == "ipu"){ return enel_ceara }
    if (uf == "ce" && municipio == "ipueiras"){ return enel_ceara }
    if (uf == "ce" && municipio == "iracema"){ return enel_ceara }
    if (uf == "ce" && municipio == "iraucuba"){ return enel_ceara }
    if (uf == "ce" && municipio == "itaicaba"){ return enel_ceara }
    if (uf == "ce" && municipio == "itaitinga"){ return enel_ceara }
    if (uf == "ce" && municipio == "itapaje"){ return enel_ceara }
    if (uf == "ce" && municipio == "itapipoca"){ return enel_ceara }
    if (uf == "ce" && municipio == "itapiuna"){ return enel_ceara }
    if (uf == "ce" && municipio == "itarema"){ return enel_ceara }
    if (uf == "ce" && municipio == "itatira"){ return enel_ceara }
    if (uf == "ce" && municipio == "jaguaretama"){ return enel_ceara }
    if (uf == "ce" && municipio == "jaguaribara"){ return enel_ceara }
    if (uf == "ce" && municipio == "jaguaribe"){ return enel_ceara }
    if (uf == "ce" && municipio == "jaguaruana"){ return enel_ceara }
    if (uf == "ce" && municipio == "jaibaras"){ return enel_ceara }
    if (uf == "ce" && municipio == "jardim"){ return enel_ceara }
    if (uf == "ce" && municipio == "jati"){ return enel_ceara }
    if (uf == "ce" && municipio == "jijoca de jericoacoara"){ return enel_ceara }
    if (uf == "ce" && municipio == "juazeiro do norte"){ return enel_ceara }
    if (uf == "ce" && municipio == "jucas"){ return enel_ceara }
    if (uf == "ce" && municipio == "lavras da mangabeira"){ return enel_ceara }
    if (uf == "ce" && municipio == "limoeiro do norte"){ return enel_ceara }
    if (uf == "ce" && municipio == "madalena"){ return enel_ceara }
    if (uf == "ce" && municipio == "maracanau"){ return enel_ceara }
    if (uf == "ce" && municipio == "maranguape"){ return enel_ceara }
    if (uf == "ce" && municipio == "marco"){ return enel_ceara }
    if (uf == "ce" && municipio == "martinopole"){ return enel_ceara }
    if (uf == "ce" && municipio == "massape"){ return enel_ceara }
    if (uf == "ce" && municipio == "mauriti"){ return enel_ceara }
    if (uf == "ce" && municipio == "meruoca"){ return enel_ceara }
    if (uf == "ce" && municipio == "milagres"){ return enel_ceara }
    if (uf == "ce" && municipio == "milha"){ return enel_ceara }
    if (uf == "ce" && municipio == "miraima"){ return enel_ceara }
    if (uf == "ce" && municipio == "missao velha"){ return enel_ceara }
    if (uf == "ce" && municipio == "mombaca"){ return enel_ceara }
    if (uf == "ce" && municipio == "monsenhor tabosa"){ return enel_ceara }
    if (uf == "ce" && municipio == "morada nova"){ return enel_ceara }
    if (uf == "ce" && municipio == "moraujo"){ return enel_ceara }
    if (uf == "ce" && municipio == "morrinhos"){ return enel_ceara }
    if (uf == "ce" && municipio == "mucambo"){ return enel_ceara }
    if (uf == "ce" && municipio == "mulungu"){ return enel_ceara }
    if (uf == "ce" && municipio == "nova olinda"){ return enel_ceara }
    if (uf == "ce" && municipio == "nova russas"){ return enel_ceara }
    if (uf == "ce" && municipio == "novo oriente"){ return enel_ceara }
    if (uf == "ce" && municipio == "ocara"){ return enel_ceara }
    if (uf == "ce" && municipio == "oros"){ return enel_ceara }
    if (uf == "ce" && municipio == "pacajus"){ return enel_ceara }
    if (uf == "ce" && municipio == "pacatuba"){ return enel_ceara }
    if (uf == "ce" && municipio == "pacoti"){ return enel_ceara }
    if (uf == "ce" && municipio == "pacuja"){ return enel_ceara }
    if (uf == "ce" && municipio == "palhano"){ return enel_ceara }
    if (uf == "ce" && municipio == "palmacia"){ return enel_ceara }
    if (uf == "ce" && municipio == "paracuru"){ return enel_ceara }
    if (uf == "ce" && municipio == "paraipaba"){ return enel_ceara }
    if (uf == "ce" && municipio == "parambu"){ return enel_ceara }
    if (uf == "ce" && municipio == "paramoti"){ return enel_ceara }
    if (uf == "ce" && municipio == "pedra branca"){ return enel_ceara }
    if (uf == "ce" && municipio == "penaforte"){ return enel_ceara }
    if (uf == "ce" && municipio == "pentecoste"){ return enel_ceara }
    if (uf == "ce" && municipio == "pereiro"){ return enel_ceara }
    if (uf == "ce" && municipio == "pindoretama"){ return enel_ceara }
    if (uf == "ce" && municipio == "piquet carneiro"){ return enel_ceara }
    if (uf == "ce" && municipio == "pires ferreira"){ return enel_ceara }
    if (uf == "ce" && municipio == "poranga"){ return enel_ceara }
    if (uf == "ce" && municipio == "porteiras"){ return enel_ceara }
    if (uf == "ce" && municipio == "potengi"){ return enel_ceara }
    if (uf == "ce" && municipio == "potiretama"){ return enel_ceara }
    if (uf == "ce" && municipio == "quiterianopolis"){ return enel_ceara }
    if (uf == "ce" && municipio == "quixada"){ return enel_ceara }
    if (uf == "ce" && municipio == "quixelo"){ return enel_ceara }
    if (uf == "ce" && municipio == "quixeramobim"){ return enel_ceara }
    if (uf == "ce" && municipio == "quixere"){ return enel_ceara }
    if (uf == "ce" && municipio == "redencao"){ return enel_ceara }
    if (uf == "ce" && municipio == "reriutaba"){ return enel_ceara }
    if (uf == "ce" && municipio == "russas"){ return enel_ceara }
    if (uf == "ce" && municipio == "saboeiro"){ return enel_ceara }
    if (uf == "ce" && municipio == "salitre"){ return enel_ceara }
    if (uf == "ce" && municipio == "santa quiteria"){ return enel_ceara }
    if (uf == "ce" && municipio == "santana do acarau"){ return enel_ceara }
    if (uf == "ce" && municipio == "santana do cariri"){ return enel_ceara }
    if (uf == "ce" && municipio == "sao benedito"){ return enel_ceara }
    if (uf == "ce" && municipio == "sao goncalo do amarante"){ return enel_ceara }
    if (uf == "ce" && municipio == "sao joao do jaguaribe"){ return enel_ceara }
    if (uf == "ce" && municipio == "sao luis do curu"){ return enel_ceara }
    if (uf == "ce" && municipio == "sapupara"){ return enel_ceara }
    if (uf == "ce" && municipio == "senador pompeu"){ return enel_ceara }
    if (uf == "ce" && municipio == "senador sá"){ return enel_ceara }
    if (uf == "ce" && municipio == "sobral"){ return enel_ceara }
    if (uf == "ce" && municipio == "solonopole"){ return enel_ceara }
    if (uf == "ce" && municipio == "tabuleiro do norte"){ return enel_ceara }
    if (uf == "ce" && municipio == "tamboril"){ return enel_ceara }
    if (uf == "ce" && municipio == "tarrafas"){ return enel_ceara }
    if (uf == "ce" && municipio == "taua"){ return enel_ceara }
    if (uf == "ce" && municipio == "tejucuoca"){ return enel_ceara }
    if (uf == "ce" && municipio == "tiangua"){ return enel_ceara }
    if (uf == "ce" && municipio == "trairi"){ return enel_ceara }
    if (uf == "ce" && municipio == "tururu"){ return enel_ceara }
    if (uf == "ce" && municipio == "ubajara"){ return enel_ceara }
    if (uf == "ce" && municipio == "umari"){ return enel_ceara }
    if (uf == "ce" && municipio == "umirim"){ return enel_ceara }
    if (uf == "ce" && municipio == "uruburetama"){ return enel_ceara }
    if (uf == "ce" && municipio == "uruoca"){ return enel_ceara }
    if (uf == "ce" && municipio == "varjota"){ return enel_ceara }
    if (uf == "ce" && municipio == "varzea alegre"){ return enel_ceara }
    if (uf == "ce" && municipio == "vicosa do ceara"){ return enel_ceara }
    if (uf == "rj" && municipio == "sao goncalo"){ return enel_rio_janeiro }
    if (uf == "rj" && municipio == "duque de caxias"){ return enel_rio_janeiro }
    if (uf == "rj" && municipio == "niteroi"){ return enel_rio_janeiro }
    if (uf == "rj" && municipio == "campos dos goytacazes"){ return enel_rio_janeiro }
    if (uf == "rj" && municipio == "petropolis"){ return enel_rio_janeiro }
    if (uf == "rj" && municipio == "mage"){ return enel_rio_janeiro }
    if (uf == "rj" && municipio == "itaborai"){ return enel_rio_janeiro }
    if (uf == "rj" && municipio == "macae"){ return enel_rio_janeiro }
    if (uf == "rj" && municipio == "cabo frio"){ return enel_rio_janeiro }
    if (uf == "rj" && municipio == "nova friburgo"){ return enel_rio_janeiro }
    if (uf == "rj" && municipio == "angra dos reis"){ return enel_rio_janeiro }
    if (uf == "rj" && municipio == "teresopolis"){ return enel_rio_janeiro }
    if (uf == "rj" && municipio == "marica"){ return enel_rio_janeiro }
    if (uf == "rj" && municipio == "resende"){ return enel_rio_janeiro }
    if (uf == "rj" && municipio == "araruama"){ return enel_rio_janeiro }
    if (uf == "rj" && municipio == "rio das ostras"){ return enel_rio_janeiro }
    if (uf == "rj" && municipio == "itaperuna"){ return enel_rio_janeiro }
    if (uf == "rj" && municipio == "sao pedro da aldeia"){ return enel_rio_janeiro }
    if (uf == "rj" && municipio == "tres rios"){ return enel_rio_janeiro }
    if (uf == "rj" && municipio == "saquarema"){ return enel_rio_janeiro }
    if (uf == "rj" && municipio == "rio bonito"){ return enel_rio_janeiro }
    if (uf == "rj" && municipio == "cachoeiras de macacu"){ return enel_rio_janeiro }
    if (uf == "rj" && municipio == "guapimirim"){ return enel_rio_janeiro }
    if (uf == "rj" && municipio == "sao francisco de itabapoana"){ return enel_rio_janeiro }
    if (uf == "rj" && municipio == "paraiba do sul"){ return enel_rio_janeiro }
    if (uf == "rj" && municipio == "santo antonio de padua"){ return enel_rio_janeiro }
    if (uf == "rj" && municipio == "sao fidelis"){ return enel_rio_janeiro }
    if (uf == "rj" && municipio == "paraty"){ return enel_rio_janeiro }
    if (uf == "rj" && municipio == "mangaratiba"){ return enel_rio_janeiro }
    if (uf == "rj" && municipio == "bom jesus do itabapoana"){ return enel_rio_janeiro }
    if (uf == "rj" && municipio == "casimiro de abreu"){ return enel_rio_janeiro }
    if (uf == "rj" && municipio == "sao joao da barra"){ return enel_rio_janeiro }
    if (uf == "rj" && municipio == "tangua"){ return enel_rio_janeiro }
    if (uf == "rj" && municipio == "itatiaia"){ return enel_rio_janeiro }
    if (uf == "rj" && municipio == "arraial do cabo"){ return enel_rio_janeiro }
    if (uf == "rj" && municipio == "armacao dos buzios"){ return enel_rio_janeiro }
    if (uf == "rj" && municipio == "miracema"){ return enel_rio_janeiro }
    if (uf == "rj" && municipio == "bom jardim"){ return enel_rio_janeiro }
    if (uf == "rj" && municipio == "itaocara"){ return enel_rio_janeiro }
    if (uf == "rj" && municipio == "iguaba grande"){ return enel_rio_janeiro }
    if (uf == "rj" && municipio == "silva jardim"){ return enel_rio_janeiro }
    if (uf == "rj" && municipio == "conceicao de macabu"){ return enel_rio_janeiro }
    if (uf == "rj" && municipio == "cordeiro"){ return enel_rio_janeiro }
    if (uf == "rj" && municipio == "sao jose do vale do rio preto"){ return enel_rio_janeiro }
    if (uf == "rj" && municipio == "quissama"){ return enel_rio_janeiro }
    if (uf == "rj" && municipio == "cantagalo"){ return enel_rio_janeiro }
    if (uf == "rj" && municipio == "porciuncula"){ return enel_rio_janeiro }
    if (uf == "rj" && municipio == "carmo"){ return enel_rio_janeiro }
    if (uf == "rj" && municipio == "porto real"){ return enel_rio_janeiro }
    if (uf == "rj" && municipio == "natividade"){ return enel_rio_janeiro }
    if (uf == "rj" && municipio == "sumidouro"){ return enel_rio_janeiro }
    if (uf == "rj" && municipio == "cambuci"){ return enel_rio_janeiro }
    if (uf == "rj" && municipio == "italva"){ return enel_rio_janeiro }
    if (uf == "rj" && municipio == "carapebus"){ return enel_rio_janeiro }
    if (uf == "rj" && municipio == "cardoso moreira"){ return enel_rio_janeiro }
    if (uf == "rj" && municipio == "areal"){ return enel_rio_janeiro }
    if (uf == "rj" && municipio == "duas barras"){ return enel_rio_janeiro }
    if (uf == "rj" && municipio == "santa maria madalena"){ return enel_rio_janeiro }
    if (uf == "rj" && municipio == "trajano de moraes"){ return enel_rio_janeiro }
    if (uf == "rj" && municipio == "aperibe"){ return enel_rio_janeiro }
    if (uf == "rj" && municipio == "varre-sai"){ return enel_rio_janeiro }
    if (uf == "rj" && municipio == "sao sebastiao do alto"){ return enel_rio_janeiro }
    if (uf == "rj" && municipio == "laje do muriae"){ return enel_rio_janeiro }
    if (uf == "rj" && municipio == "sao jose de uba"){ return enel_rio_janeiro }
    if (uf == "rj" && municipio == "macuco"){ return enel_rio_janeiro }
    if (uf == "sp" && municipio == "aguas de lindoia"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "aguas de santa barbara"){ return cpfl_santa_cruz }
    if (uf == "sp" && municipio == "agudos"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "alambari"){ return cpfl_santa_cruz }
    if (uf == "sp" && municipio == "altair"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "altinopolis"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "alto alegre"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "aluminio"){ return cpfl_piratininga }
    if (uf == "sp" && municipio == "alvaro de carvalho"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "alvinlandia"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "americana"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "americo brasiliense"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "amparo"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "analandia"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "aracariguama"){ return cpfl_piratininga }
    if (uf == "sp" && municipio == "aracatuba"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "aracoiaba da serra"){ return cpfl_piratininga }
    if (uf == "sp" && municipio == "aramina"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "arandu"){ return cpfl_santa_cruz }
    if (uf == "sp" && municipio == "araraquara"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "arealva"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "areiopolis"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "ariranha"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "avai"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "avanhandava"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "avare"){ return cpfl_santa_cruz }
    if (uf == "sp" && municipio == "bady bassitt"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "balbinos"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "balsamo"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "barbosa"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "bariri"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "barra bonita"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "barretos"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "barrinha"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "barueri"){ return enel_sao_paulo }
    if (uf == "sp" && municipio == "batatais"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "bauru"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "bebedouro"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "bento de abreu"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "bernardino de campos"){ return cpfl_santa_cruz }
    if (uf == "sp" && municipio == "bilac"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "birigui"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "boa esperanca do sul"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "bocaina"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "bofete"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "boituva"){ return cpfl_piratininga }
    if (uf == "sp" && municipio == "boraceia"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "borebi"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "botucatu"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "brauna"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "brejo alegre"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "brodowski"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "brotas"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "buritizal"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "cabralia paulista"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "caconde"){ return cpfl_santa_cruz }
    if (uf == "sp" && municipio == "cafelandia"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "cajamar"){ return enel_sao_paulo }
    if (uf == "sp" && municipio == "cajobi"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "cajuru"){ return imagem_cpfl_paulista }
    
    
    if (uf == "sp" && municipio == "campinas"){ return imagem_cpfl_paulista }


    if (uf == "sp" && municipio == "campo limpo paulista"){ return cpfl_piratininga }
    if (uf == "sp" && municipio == "campos novos paulista"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "candido rodrigues"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "canitar"){ return cpfl_santa_cruz }
    if (uf == "sp" && municipio == "capela do alto"){ return cpfl_piratininga }
    if (uf == "sp" && municipio == "capivari"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "carapicuiba"){ return enel_sao_paulo }
    if (uf == "sp" && municipio == "casa branca"){ return cpfl_santa_cruz }
    if (uf == "sp" && municipio == "cassia dos coqueiros"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "cedral"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "cerqueira cesar"){ return cpfl_santa_cruz }
    if (uf == "sp" && municipio == "charqueada"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "chavantes"){ return cpfl_santa_cruz }
    if (uf == "sp" && municipio == "clementina"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "colina"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "colombia"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "coroados"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "cosmopolis"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "cotia"){ return enel_sao_paulo }
    if (uf == "sp" && municipio == "cravinhos"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "cristais paulista"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "cubatao"){ return cpfl_piratininga }
    if (uf == "sp" && municipio == "descalvado"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "diadema"){ return enel_sao_paulo }
    if (uf == "sp" && municipio == "divinolandia"){ return cpfl_santa_cruz }
    if (uf == "sp" && municipio == "dobrada"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "dois corregos"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "dourado"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "duartina"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "dumont"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "elias fausto"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "embauba"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "embu das artes"){ return enel_sao_paulo }
    if (uf == "sp" && municipio == "embu-guacu"){ return enel_sao_paulo }
    if (uf == "sp" && municipio == "espirito santo do pinhal"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "espirito santo do turvo"){ return cpfl_santa_cruz }
    if (uf == "sp" && municipio == "fernao"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "franca"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "gabriel monteiro"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "galia"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "garca"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "gaviao peixoto"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "getulina"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "glicerio"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "guaicara"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "guaimbe"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "guaira"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "guapiacu"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "guara"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "guaraci"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "guaranta"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "guararapes"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "guarei"){ return cpfl_santa_cruz }
    if (uf == "sp" && municipio == "guariba"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "guaruja (vicente de carvalho)"){ return cpfl_piratininga }
    if (uf == "sp" && municipio == "guatapara"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "herculandia"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "hortolandia"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "iacanga"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "iaras"){ return cpfl_santa_cruz }
    if (uf == "sp" && municipio == "ibate"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "ibira"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "ibitinga"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "ibiuna"){ return cpfl_piratininga }
    if (uf == "sp" && municipio == "icem"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "igaracu do tiete"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "igarapava"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "indaiatuba"){ return cpfl_piratininga }
    if (uf == "sp" && municipio == "ipaussu"){ return cpfl_santa_cruz }
    if (uf == "sp" && municipio == "ipero"){ return cpfl_piratininga }
    if (uf == "sp" && municipio == "ipigua"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "ipua"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "itai"){ return cpfl_santa_cruz }
    if (uf == "sp" && municipio == "itaju"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "itapecerica da serra"){ return enel_sao_paulo }
    if (uf == "sp" && municipio == "itapetininga"){ return cpfl_santa_cruz }
    if (uf == "sp" && municipio == "itapevi"){ return enel_sao_paulo }
    if (uf == "sp" && municipio == "itapira"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "itapolis"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "itapui"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "itatiba"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "itatinga"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "itirapua"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "itobi"){ return cpfl_santa_cruz }
    if (uf == "sp" && municipio == "itu"){ return cpfl_piratininga }
    if (uf == "sp" && municipio == "itupeva"){ return cpfl_piratininga }
    if (uf == "sp" && municipio == "ituverava"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "jaborandi"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "jaboticabal"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "jaci"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "jaguariuna"){ return cpfl_santa_cruz }
    if (uf == "sp" && municipio == "jandira"){ return enel_sao_paulo }
    if (uf == "sp" && municipio == "jardinopolis"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "jau"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "jeriquara"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "jose bonifacio"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "julio mesquita"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "jundiai"){ return cpfl_piratininga }
    if (uf == "sp" && municipio == "juquitiba"){ return enel_sao_paulo }
    if (uf == "sp" && municipio == "lencois paulista"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "lindoia"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "lins"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "louveira"){ return cpfl_piratininga }
    if (uf == "sp" && municipio == "lucianopolis"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "luis antonio"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "luiziania"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "lupercio"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "macatuba"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "mairinque"){ return cpfl_piratininga }
    if (uf == "sp" && municipio == "manduri"){ return cpfl_santa_cruz }
    if (uf == "sp" && municipio == "marilia"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "matao"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "maua"){ return enel_sao_paulo }
    if (uf == "sp" && municipio == "miguelopolis"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "mineiros do tiete"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "mirassol"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "mirassolandia"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "mococa"){ return cpfl_santa_cruz }
    if (uf == "sp" && municipio == "mombuca"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "monte alegre do sul"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "monte alto"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "monte aprazivel"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "monte azul paulista"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "monte mor"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "morro agudo"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "morungaba"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "motuca"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "neves paulista"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "nova europa"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "nova granada"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "nova odessa"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "nuporanga"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "ocaucu"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "oleo"){ return cpfl_santa_cruz }
    if (uf == "sp" && municipio == "olimpia"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "onda verde"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "oriente"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "orlandia"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "osasco"){ return enel_sao_paulo }
    if (uf == "sp" && municipio == "ourinhos"){ return cpfl_santa_cruz }
    if (uf == "sp" && municipio == "palestina"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "palmares paulista"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "paraiso"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "paranapanema"){ return cpfl_santa_cruz }
    if (uf == "sp" && municipio == "pardinho"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "patrocinio paulista"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "paulinia"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "paulistania"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "pederneiras"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "pedregulho"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "pedreira"){ return cpfl_santa_cruz }
    if (uf == "sp" && municipio == "penapolis"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "piacatu"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "pindorama"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "piracicaba"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "piraju"){ return cpfl_santa_cruz }
    if (uf == "sp" && municipio == "pirajui"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "pirangi"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "pirapora do bom jesus"){ return enel_sao_paulo }
    if (uf == "sp" && municipio == "piratininga"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "pitangueiras"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "poloni"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "pompeia"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "pongai"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "pontal"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "porto feliz"){ return cpfl_piratininga }
    if (uf == "sp" && municipio == "potirendaba"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "pradopolis"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "praia grande"){ return cpfl_piratininga }
    if (uf == "sp" && municipio == "pratania"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "presidente alves"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "promissao"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "queiroz"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "quintana"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "rafard"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "reginopolis"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "restinga"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "ribeirao bonito"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "ribeirao corrente"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "ribeirao pires"){ return enel_sao_paulo }
    if (uf == "sp" && municipio == "ribeirao preto"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "rifaina"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "rincao"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "rio das pedras"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "rio grande da serra"){ return enel_sao_paulo }
    if (uf == "sp" && municipio == "rubiacea"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "sabino"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "sales oliveira"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "saltinho"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "salto"){ return cpfl_piratininga }
    if (uf == "sp" && municipio == "salto de pirapora"){ return cpfl_piratininga }
    if (uf == "sp" && municipio == "santa adelia"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "santa barbara d oeste"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "santa cruz da esperanca"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "santa cruz do rio pardo"){ return cpfl_santa_cruz }
    if (uf == "sp" && municipio == "santa ernestina"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "santa lucia"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "santa maria da serra"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "santa rosa de viterbo"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "santana de parnaiba"){ return enel_sao_paulo }
    if (uf == "sp" && municipio == "santo andre"){ return enel_sao_paulo }
    if (uf == "sp" && municipio == "santo antonio da alegria"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "santo antonio do aracangua"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "santo antonio do jardim"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "santopolis do aguapei"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "santos"){ return cpfl_piratininga }
    if (uf == "sp" && municipio == "sao bernardo do campo"){ return enel_sao_paulo }
    if (uf == "sp" && municipio == "sao caetano do sul"){ return enel_sao_paulo }
    if (uf == "sp" && municipio == "sao carlos"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "sao joaquim da barra"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "sao jose da bela vista"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "sao jose do rio pardo"){ return cpfl_santa_cruz }
    if (uf == "sp" && municipio == "sao jose do rio preto"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "sao lourenco da serra"){ return enel_sao_paulo }
    if (uf == "sp" && municipio == "sao manuel"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "sao miguel arcanjo"){ return cpfl_santa_cruz }
    if (uf == "sp" && municipio == "são paulo"){ return enel_sao_paulo }
    if (uf == "sp" && municipio == "sao pedro"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "sao pedro do turvo"){ return cpfl_santa_cruz }
    if (uf == "sp" && municipio == "sao roque"){ return cpfl_piratininga }
    if (uf == "sp" && municipio == "sao sebastiao da grama"){ return cpfl_santa_cruz }
    if (uf == "sp" && municipio == "sao simao"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "sao vicente"){ return cpfl_piratininga }
    if (uf == "sp" && municipio == "sarapui"){ return cpfl_santa_cruz }
    if (uf == "sp" && municipio == "sarutaia"){ return cpfl_santa_cruz }
    if (uf == "sp" && municipio == "serra azul"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "serra negra"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "serrana"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "sertaozinho"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "severinia"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "socorro"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "sorocaba"){ return cpfl_piratininga }
    if (uf == "sp" && municipio == "sumare"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "tabatinga"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "taboao da serra"){ return enel_sao_paulo }
    if (uf == "sp" && municipio == "taguai"){ return cpfl_santa_cruz }
    if (uf == "sp" && municipio == "taiacu"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "taiuva"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "tanabi"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "tapiratiba"){ return cpfl_santa_cruz }
    if (uf == "sp" && municipio == "taquaral"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "taquaritinga"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "taquarituba"){ return cpfl_santa_cruz }
    if (uf == "sp" && municipio == "tejupa"){ return cpfl_santa_cruz }
    if (uf == "sp" && municipio == "terra roxa"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "timburi"){ return cpfl_santa_cruz }
    if (uf == "sp" && municipio == "torrinha"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "trabiju"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "ubarana"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "ubirajara"){ return cpfl_santa_cruz }
    if (uf == "sp" && municipio == "uchoa"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "uru"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "valinhos"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "valparaiso"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "vargem grande paulista"){ return enel_sao_paulo }
    if (uf == "sp" && municipio == "varzea paulista"){ return cpfl_piratininga }
    if (uf == "sp" && municipio == "vera cruz"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "vinhedo"){ return cpfl_piratininga }
    if (uf == "sp" && municipio == "viradouro"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "vista alegre do alto"){ return imagem_cpfl_paulista }
    if (uf == "sp" && municipio == "votorantim"){ return cpfl_piratininga }
    if (uf == "rs" && municipio == "agua santa"){ return rge }
    if (uf == "rs" && municipio == "agudo"){ return rge_sul }
    if (uf == "rs" && municipio == "ajuricaba"){ return rge }
    if (uf == "rs" && municipio == "alecrim"){ return rge }
    if (uf == "rs" && municipio == "alegrete"){ return rge_sul }
    if (uf == "rs" && municipio == "alegria"){ return rge }
    if (uf == "rs" && municipio == "alpestre"){ return rge }
    if (uf == "rs" && municipio == "alto feliz"){ return rge }
    if (uf == "rs" && municipio == "ametista do sul"){ return rge }
    if (uf == "rs" && municipio == "andre da rocha"){ return rge }
    if (uf == "rs" && municipio == "anta gorda"){ return rge }
    if (uf == "rs" && municipio == "antonio prado"){ return rge }
    if (uf == "rs" && municipio == "ararica"){ return rge_sul }
    if (uf == "rs" && municipio == "aratiba"){ return rge }
    if (uf == "rs" && municipio == "arroio do meio"){ return rge_sul }
    if (uf == "rs" && municipio == "arroio do sal"){ return rge }
    if (uf == "rs" && municipio == "arroio do tigre"){ return rge_sul }
    if (uf == "rs" && municipio == "arvorezinha"){ return rge }
    if (uf == "rs" && municipio == "augusto pestana"){ return rge }
    if (uf == "rs" && municipio == "aurea"){ return rge }
    if (uf == "rs" && municipio == "barao"){ return rge }
    if (uf == "rs" && municipio == "barao de cotegipe"){ return rge }
    if (uf == "rs" && municipio == "barra do guarita"){ return rge }
    if (uf == "rs" && municipio == "barra do quarai"){ return rge_sul }
    if (uf == "rs" && municipio == "barra do rio azul"){ return rge }
    if (uf == "rs" && municipio == "barra funda"){ return rge }
    if (uf == "rs" && municipio == "barracao"){ return rge }
    if (uf == "rs" && municipio == "barros cassal"){ return rge }
    if (uf == "rs" && municipio == "benjamin constant do sul"){ return rge }
    if (uf == "rs" && municipio == "bento goncalves"){ return rge }
    if (uf == "rs" && municipio == "boa vista das missoes"){ return rge }
    if (uf == "rs" && municipio == "boa vista do burica"){ return rge }
    if (uf == "rs" && municipio == "boa vista do cadeado"){ return rge }
    if (uf == "rs" && municipio == "boa vista do sul"){ return rge }
    if (uf == "rs" && municipio == "bom jesus"){ return rge }
    if (uf == "rs" && municipio == "bom principio"){ return rge_sul }
    if (uf == "rs" && municipio == "bom progresso"){ return rge }
    if (uf == "rs" && municipio == "bom retiro do sul"){ return rge_sul }
    if (uf == "rs" && municipio == "boqueirao do leao"){ return rge_sul }
    if (uf == "rs" && municipio == "bossoroca"){ return rge_sul }
    if (uf == "rs" && municipio == "bozano"){ return rge }
    if (uf == "rs" && municipio == "braga"){ return rge }
    if (uf == "rs" && municipio == "brochier"){ return rge_sul }
    if (uf == "rs" && municipio == "cacapava do sul"){ return rge_sul }
    if (uf == "rs" && municipio == "cacequi"){ return rge_sul }
    if (uf == "rs" && municipio == "cachoeira do sul"){ return rge_sul }
    if (uf == "rs" && municipio == "cachoeirinha"){ return rge }
    if (uf == "rs" && municipio == "cacique doble"){ return rge }
    if (uf == "rs" && municipio == "caicara"){ return rge }
    if (uf == "rs" && municipio == "camargo"){ return rge }
    if (uf == "rs" && municipio == "cambara do sul"){ return rge }
    if (uf == "rs" && municipio == "campestre da serra"){ return rge }
    if (uf == "rs" && municipio == "campina das missoes"){ return rge }
    if (uf == "rs" && municipio == "campinas do sul"){ return rge }
    if (uf == "rs" && municipio == "campo bom"){ return rge_sul }
    if (uf == "rs" && municipio == "campo novo"){ return rge }
    if (uf == "rs" && municipio == "candelaria"){ return rge_sul }
    if (uf == "rs" && municipio == "candido godoi"){ return rge }
    if (uf == "rs" && municipio == "canela"){ return rge }
    if (uf == "rs" && municipio == "canoas"){ return rge_sul }
    if (uf == "rs" && municipio == "capao bonito do sul"){ return rge }
    if (uf == "rs" && municipio == "capao do cipo"){ return rge_sul }
    if (uf == "rs" && municipio == "capela de santana"){ return rge_sul }
    if (uf == "rs" && municipio == "carazinho"){ return rge }
    if (uf == "rs" && municipio == "carlos barbosa"){ return rge }
    if (uf == "rs" && municipio == "carlos gomes"){ return rge }
    if (uf == "rs" && municipio == "casca"){ return rge }
    if (uf == "rs" && municipio == "caseiros"){ return rge }
    if (uf == "rs" && municipio == "catuipe"){ return rge }
    if (uf == "rs" && municipio == "caxias do sul"){ return rge }
    if (uf == "rs" && municipio == "centenario"){ return rge }
    if (uf == "rs" && municipio == "cerro branco"){ return rge_sul }
    if (uf == "rs" && municipio == "cerro grande"){ return rge }
    if (uf == "rs" && municipio == "cerro largo"){ return rge }
    if (uf == "rs" && municipio == "charrua"){ return rge }
    if (uf == "rs" && municipio == "chiapetta"){ return rge }
    if (uf == "rs" && municipio == "ciriaco"){ return rge }
    if (uf == "rs" && municipio == "colinas"){ return rge_sul }
    if (uf == "rs" && municipio == "constantina"){ return rge }
    if (uf == "rs" && municipio == "coronel bicaco"){ return rge }
    if (uf == "rs" && municipio == "coronel pilar"){ return rge }
    if (uf == "rs" && municipio == "cotipora"){ return rge }
    if (uf == "rs" && municipio == "coxilha"){ return rge }
    if (uf == "rs" && municipio == "crissiumal"){ return rge }
    if (uf == "rs" && municipio == "cristal do sul"){ return rge }
    if (uf == "rs" && municipio == "cruz alta"){ return rge }
    if (uf == "rs" && municipio == "cruzaltense"){ return rge }
    if (uf == "rs" && municipio == "cruzeiro do sul"){ return rge_sul }
    if (uf == "rs" && municipio == "david canabarro"){ return rge }
    if (uf == "rs" && municipio == "derrubadas"){ return rge }
    if (uf == "rs" && municipio == "dezesseis de novembro"){ return rge }
    if (uf == "rs" && municipio == "dilermando de aguiar"){ return rge_sul }
    if (uf == "rs" && municipio == "dois irmaos"){ return rge_sul }
    if (uf == "rs" && municipio == "dois lajeados"){ return rge }
    if (uf == "rs" && municipio == "doutor mauricio cardoso"){ return rge }
    if (uf == "rs" && municipio == "doutor ricardo"){ return rge_sul }
    if (uf == "rs" && municipio == "encantado"){ return rge_sul }
    if (uf == "rs" && municipio == "engenho velho"){ return rge }
    if (uf == "rs" && municipio == "entre rios do sul"){ return rge }
    if (uf == "rs" && municipio == "entre-ijuis"){ return rge }
    if (uf == "rs" && municipio == "erebango"){ return rge }
    if (uf == "rs" && municipio == "erechim"){ return rge }
    if (uf == "rs" && municipio == "ernestina"){ return rge }
    if (uf == "rs" && municipio == "erval grande"){ return rge }
    if (uf == "rs" && municipio == "erval seco"){ return rge }
    if (uf == "rs" && municipio == "esmeralda"){ return rge }
    if (uf == "rs" && municipio == "esperanca do sul"){ return rge }
    if (uf == "rs" && municipio == "espumoso"){ return rge }
    if (uf == "rs" && municipio == "estacao"){ return rge }
    if (uf == "rs" && municipio == "estancia velha"){ return rge_sul }
    if (uf == "rs" && municipio == "esteio"){ return rge_sul }
    if (uf == "rs" && municipio == "estrela"){ return rge_sul }
    if (uf == "rs" && municipio == "estrela velha"){ return rge_sul }
    if (uf == "rs" && municipio == "eugenio de castro"){ return rge }
    if (uf == "rs" && municipio == "fagundes varela"){ return rge }
    if (uf == "rs" && municipio == "farroupilha"){ return rge }
    if (uf == "rs" && municipio == "faxinalzinho"){ return rge }
    if (uf == "rs" && municipio == "fazenda vilanova"){ return rge_sul }
    if (uf == "rs" && municipio == "feliz"){ return rge }
    if (uf == "rs" && municipio == "flores da cunha"){ return rge }
    if (uf == "rs" && municipio == "formigueiro"){ return rge_sul }
    if (uf == "rs" && municipio == "fortaleza dos valos"){ return rge }
    if (uf == "rs" && municipio == "frederico westphalen"){ return rge }
    if (uf == "rs" && municipio == "garibaldi"){ return rge }
    if (uf == "rs" && municipio == "garruchos"){ return rge_sul }
    if (uf == "rs" && municipio == "gaurama"){ return rge }
    if (uf == "rs" && municipio == "general camara"){ return rge_sul }
    if (uf == "rs" && municipio == "gentil"){ return rge }
    if (uf == "rs" && municipio == "getulio vargas"){ return rge }
    if (uf == "rs" && municipio == "girua"){ return rge }
    if (uf == "rs" && municipio == "glorinha"){ return rge }
    if (uf == "rs" && municipio == "gramado"){ return rge }
    if (uf == "rs" && municipio == "gramado dos loureiros"){ return rge }
    if (uf == "rs" && municipio == "gramado xavier"){ return rge_sul }
    if (uf == "rs" && municipio == "gravatai"){ return rge }
    if (uf == "rs" && municipio == "guabiju"){ return rge }
    if (uf == "rs" && municipio == "guapore"){ return rge }
    if (uf == "rs" && municipio == "guarani das missoes"){ return rge }
    if (uf == "rs" && municipio == "harmonia"){ return rge_sul }
    if (uf == "rs" && municipio == "herveiras"){ return rge_sul }
    if (uf == "rs" && municipio == "horizontina"){ return rge }
    if (uf == "rs" && municipio == "humaita"){ return rge }
    if (uf == "rs" && municipio == "ibarama"){ return rge_sul }
    if (uf == "rs" && municipio == "ibiraiaras"){ return rge }
    if (uf == "rs" && municipio == "ibirapuita"){ return rge }
    if (uf == "rs" && municipio == "ibiruba"){ return rge }
    if (uf == "rs" && municipio == "igrejinha"){ return rge }
    if (uf == "rs" && municipio == "ijui"){ return rge }
    if (uf == "rs" && municipio == "ilopolis"){ return rge }
    if (uf == "rs" && municipio == "imigrante"){ return rge_sul }
    if (uf == "rs" && municipio == "independencia"){ return rge }
    if (uf == "rs" && municipio == "inhacora"){ return rge }
    if (uf == "rs" && municipio == "ipe"){ return rge }
    if (uf == "rs" && municipio == "ipiranga do sul"){ return rge }
    if (uf == "rs" && municipio == "irai"){ return rge }
    if (uf == "rs" && municipio == "itaara"){ return rge_sul }
    if (uf == "rs" && municipio == "itacurubi"){ return rge_sul }
    if (uf == "rs" && municipio == "itapuca"){ return rge }
    if (uf == "rs" && municipio == "itaqui"){ return rge_sul }
    if (uf == "rs" && municipio == "itatiba do sul"){ return rge }
    if (uf == "rs" && municipio == "ivora"){ return rge_sul }
    if (uf == "rs" && municipio == "ivoti"){ return rge_sul }
    if (uf == "rs" && municipio == "jacutinga"){ return rge }
    if (uf == "rs" && municipio == "jaguari"){ return rge_sul }
    if (uf == "rs" && municipio == "jaquirana"){ return rge }
    if (uf == "rs" && municipio == "jari"){ return rge }
    if (uf == "rs" && municipio == "joia"){ return rge }
    if (uf == "rs" && municipio == "julio de castilhos"){ return rge }
    if (uf == "rs" && municipio == "lagoa bonita do sul"){ return rge_sul }
    if (uf == "rs" && municipio == "lagoa dos tres cantos"){ return rge }
    if (uf == "rs" && municipio == "lagoa vermelha"){ return rge }
    if (uf == "rs" && municipio == "lagoao"){ return rge_sul }
    if (uf == "rs" && municipio == "lajeado"){ return rge_sul }
    if (uf == "rs" && municipio == "lajeado do bugre"){ return rge }
    if (uf == "rs" && municipio == "liberato salzano"){ return rge }
    if (uf == "rs" && municipio == "lindolfo collor"){ return rge_sul }
    if (uf == "rs" && municipio == "linha nova"){ return rge }
    if (uf == "rs" && municipio == "macambara"){ return rge_sul }
    if (uf == "rs" && municipio == "machadinho"){ return rge }
    if (uf == "rs" && municipio == "manoel viana"){ return rge_sul }
    if (uf == "rs" && municipio == "marata"){ return rge_sul }
    if (uf == "rs" && municipio == "marau"){ return rge }
    if (uf == "rs" && municipio == "marcelino ramos"){ return rge }
    if (uf == "rs" && municipio == "mariano moro"){ return rge }
    if (uf == "rs" && municipio == "marques de souza"){ return rge_sul }
    if (uf == "rs" && municipio == "mata"){ return rge_sul }
    if (uf == "rs" && municipio == "mato leitao"){ return rge_sul }
    if (uf == "rs" && municipio == "maximiliano de almeida"){ return rge }
    if (uf == "rs" && municipio == "miraguai"){ return rge }
    if (uf == "rs" && municipio == "montauri"){ return rge }
    if (uf == "rs" && municipio == "monte alegre dos campos"){ return rge }
    if (uf == "rs" && municipio == "monte belo do sul"){ return rge }
    if (uf == "rs" && municipio == "montenegro"){ return rge_sul }
    if (uf == "rs" && municipio == "mormaco"){ return rge }
    if (uf == "rs" && municipio == "morro reuter"){ return rge_sul }
    if (uf == "rs" && municipio == "mucum"){ return rge_sul }
    if (uf == "rs" && municipio == "muitos capoes"){ return rge }
    if (uf == "rs" && municipio == "muliterno"){ return rge }
    if (uf == "rs" && municipio == "nao-me-toque"){ return rge }
    if (uf == "rs" && municipio == "nonoai"){ return rge }
    if (uf == "rs" && municipio == "nova alvorada"){ return rge }
    if (uf == "rs" && municipio == "nova araca"){ return rge }
    if (uf == "rs" && municipio == "nova bassano"){ return rge }
    if (uf == "rs" && municipio == "nova boa vista"){ return rge }
    if (uf == "rs" && municipio == "nova brescia"){ return rge_sul }
    if (uf == "rs" && municipio == "nova candelaria"){ return rge }
    if (uf == "rs" && municipio == "nova esperanca do sul"){ return rge_sul }
    if (uf == "rs" && municipio == "nova hartz"){ return rge }
    if (uf == "rs" && municipio == "nova padua"){ return rge }
    if (uf == "rs" && municipio == "nova petropolis"){ return rge }
    if (uf == "rs" && municipio == "nova prata"){ return rge }
    if (uf == "rs" && municipio == "nova roma do sul"){ return rge }
    if (uf == "rs" && municipio == "nova santa rita"){ return rge_sul }
    if (uf == "rs" && municipio == "novo barreiro"){ return rge }
    if (uf == "rs" && municipio == "novo cabrais"){ return rge_sul }
    if (uf == "rs" && municipio == "novo hamburgo"){ return rge_sul }
    if (uf == "rs" && municipio == "novo machado"){ return rge }
    if (uf == "rs" && municipio == "novo xingu"){ return rge }
    if (uf == "rs" && municipio == "paim filho"){ return rge }
    if (uf == "rs" && municipio == "palmeira das missoes"){ return rge }
    if (uf == "rs" && municipio == "palmitinho"){ return rge }
    if (uf == "rs" && municipio == "panambi"){ return rge }
    if (uf == "rs" && municipio == "parai"){ return rge }
    if (uf == "rs" && municipio == "paraiso do sul"){ return rge_sul }
    if (uf == "rs" && municipio == "pareci novo"){ return rge_sul }
    if (uf == "rs" && municipio == "parobe"){ return rge }
    if (uf == "rs" && municipio == "passa-sete"){ return rge_sul }
    if (uf == "rs" && municipio == "passo do sobrado"){ return rge_sul }
    if (uf == "rs" && municipio == "passo fundo"){ return rge }
    if (uf == "rs" && municipio == "paulo bento"){ return rge }
    if (uf == "rs" && municipio == "paverama"){ return rge_sul }
    if (uf == "rs" && municipio == "pejucara"){ return rge }
    if (uf == "rs" && municipio == "picada cafe "){ return rge }
    if (uf == "rs" && municipio == "pinhal da serra"){ return rge }
    if (uf == "rs" && municipio == "pinhal grande"){ return rge }
    if (uf == "rs" && municipio == "pinheirinho do vale"){ return rge }
    if (uf == "rs" && municipio == "pirapo"){ return rge }
    if (uf == "rs" && municipio == "planalto"){ return rge }
    if (uf == "rs" && municipio == "ponte preta"){ return rge }
    if (uf == "rs" && municipio == "portao"){ return rge_sul }
    if (uf == "rs" && municipio == "porto lucena"){ return rge }
    if (uf == "rs" && municipio == "porto maua"){ return rge }
    if (uf == "rs" && municipio == "porto vera cruz"){ return rge }
    if (uf == "rs" && municipio == "porto xavier"){ return rge }
    if (uf == "rs" && municipio == "presidente lucena"){ return rge_sul }
    if (uf == "rs" && municipio == "protasio alves"){ return rge }
    if (uf == "rs" && municipio == "putinga"){ return rge }
    if (uf == "rs" && municipio == "quarai"){ return rge_sul }
    if (uf == "rs" && municipio == "quatro irmaos"){ return rge }
    if (uf == "rs" && municipio == "quevedos"){ return rge_sul }
    if (uf == "rs" && municipio == "quinze de novembro"){ return rge }
    if (uf == "rs" && municipio == "redentora"){ return rge }
    if (uf == "rs" && municipio == "relvado"){ return rge_sul }
    if (uf == "rs" && municipio == "rio dos indios"){ return rge }
    if (uf == "rs" && municipio == "rio pardo"){ return rge_sul }
    if (uf == "rs" && municipio == "riozinho"){ return rge }
    if (uf == "rs" && municipio == "roca sales"){ return rge_sul }
    if (uf == "rs" && municipio == "rolador"){ return rge }
    if (uf == "rs" && municipio == "rolante"){ return rge }
    if (uf == "rs" && municipio == "ronda alta"){ return rge }
    if (uf == "rs" && municipio == "rondinha"){ return rge }
    if (uf == "rs" && municipio == "roque gonzales"){ return rge }
    if (uf == "rs" && municipio == "rosario do sul"){ return rge_sul }
    if (uf == "rs" && municipio == "sagrada familia"){ return rge }
    if (uf == "rs" && municipio == "saldanha marinho"){ return rge }
    if (uf == "rs" && municipio == "salto do jacui"){ return rge }
    if (uf == "rs" && municipio == "salvador das missoes"){ return rge }
    if (uf == "rs" && municipio == "salvador do sul"){ return rge_sul }
    if (uf == "rs" && municipio == "sananduva"){ return rge }
    if (uf == "rs" && municipio == "santa barbara do sul"){ return rge }
    if (uf == "rs" && municipio == "santa cruz do sul"){ return rge_sul }
    if (uf == "rs" && municipio == "santa maria"){ return rge_sul }
    if (uf == "rs" && municipio == "santa maria do herval"){ return rge_sul }
    if (uf == "rs" && municipio == "santa rosa"){ return rge }
    if (uf == "rs" && municipio == "santa tereza"){ return rge }
    if (uf == "rs" && municipio == "santana da boa vista"){ return rge_sul }
    if (uf == "rs" && municipio == "santana do livramento"){ return rge_sul }
    if (uf == "rs" && municipio == "santiago"){ return rge_sul }
    if (uf == "rs" && municipio == "santo angelo"){ return rge }
    if (uf == "rs" && municipio == "santo antonio da patrulha"){ return rge }
    if (uf == "rs" && municipio == "santo antonio das missoes"){ return rge_sul }
    if (uf == "rs" && municipio == "santo antonio do palma"){ return rge }
    if (uf == "rs" && municipio == "santo augusto"){ return rge }
    if (uf == "rs" && municipio == "santo cristo"){ return rge }
    if (uf == "rs" && municipio == "santo expedito do sul"){ return rge }
    if (uf == "rs" && municipio == "sao borja"){ return rge_sul }
    if (uf == "rs" && municipio == "sao domingos do sul"){ return rge }
    if (uf == "rs" && municipio == "sao francisco de assis"){ return rge_sul }
    if (uf == "rs" && municipio == "sao francisco de paula"){ return rge }
    if (uf == "rs" && municipio == "sao gabriel"){ return rge_sul }
    if (uf == "rs" && municipio == "sao joao da urtiga"){ return rge }
    if (uf == "rs" && municipio == "sao joao do polesine"){ return rge_sul }
    if (uf == "rs" && municipio == "sao jorge"){ return rge }
    if (uf == "rs" && municipio == "sao jose das missoes"){ return rge }
    if (uf == "rs" && municipio == "sao jose do hortencio"){ return rge_sul }
    if (uf == "rs" && municipio == "sao jose do inhacora"){ return rge }
    if (uf == "rs" && municipio == "sao jose do ouro"){ return rge }
    if (uf == "rs" && municipio == "sao jose dos ausentes"){ return rge }
    if (uf == "rs" && municipio == "sao leopoldo"){ return rge_sul }
    if (uf == "rs" && municipio == "sao luiz gonzaga"){ return rge }
    if (uf == "rs" && municipio == "sao marcos"){ return rge }
    if (uf == "rs" && municipio == "sao martinho"){ return rge }
    if (uf == "rs" && municipio == "sao martinho da serra"){ return rge_sul }
    if (uf == "rs" && municipio == "sao miguel das missoes"){ return rge_sul }
    if (uf == "rs" && municipio == "sao nicolau"){ return rge }
    if (uf == "rs" && municipio == "sao paulo das missoes"){ return rge }
    if (uf == "rs" && municipio == "sao pedro das missoes"){ return rge }
    if (uf == "rs" && municipio == "sao pedro do butia"){ return rge }
    if (uf == "rs" && municipio == "sao pedro do sul"){ return rge_sul }
    if (uf == "rs" && municipio == "sao sebastiao do cai"){ return rge_sul }
    if (uf == "rs" && municipio == "sao sepe"){ return rge_sul }
    if (uf == "rs" && municipio == "sao valentim"){ return rge }
    if (uf == "rs" && municipio == "sao valentim do sul"){ return rge }
    if (uf == "rs" && municipio == "sao valerio do sul"){ return rge }
    if (uf == "rs" && municipio == "sao vendelino"){ return rge_sul }
    if (uf == "rs" && municipio == "sao vicente do sul"){ return rge_sul }
    if (uf == "rs" && municipio == "sapiranga"){ return rge_sul }
    if (uf == "rs" && municipio == "sapucaia do sul"){ return rge_sul }
    if (uf == "rs" && municipio == "sarandi"){ return rge }
    if (uf == "rs" && municipio == "seberi"){ return rge }
    if (uf == "rs" && municipio == "sede nova"){ return rge }
    if (uf == "rs" && municipio == "segredo"){ return rge_sul }
    if (uf == "rs" && municipio == "selbach"){ return rge }
    if (uf == "rs" && municipio == "senador salgado filho"){ return rge }
    if (uf == "rs" && municipio == "serafina correa"){ return rge }
    if (uf == "rs" && municipio == "sertao"){ return rge }
    if (uf == "rs" && municipio == "sete de setembro"){ return rge }
    if (uf == "rs" && municipio == "severiano de almeida"){ return rge }
    if (uf == "rs" && municipio == "silveira martins"){ return rge_sul }
    if (uf == "rs" && municipio == "sinimbu"){ return rge_sul }
    if (uf == "rs" && municipio == "sobradinho"){ return rge_sul }
    if (uf == "rs" && municipio == "soledade"){ return rge }
    if (uf == "rs" && municipio == "tabai"){ return rge_sul }
    if (uf == "rs" && municipio == "tapejara"){ return rge }
    if (uf == "rs" && municipio == "tapera"){ return rge }
    if (uf == "rs" && municipio == "taquara"){ return rge }
    if (uf == "rs" && municipio == "taquari"){ return rge_sul }
    if (uf == "rs" && municipio == "taquarucu do sul"){ return rge }
    if (uf == "rs" && municipio == "tenente portela"){ return rge }
    if (uf == "rs" && municipio == "tio hugo"){ return rge }
    if (uf == "rs" && municipio == "tiradentes do sul"){ return rge }
    if (uf == "rs" && municipio == "toropi"){ return rge_sul }
    if (uf == "rs" && municipio == "travesseiro"){ return rge_sul }
    if (uf == "rs" && municipio == "tres arroios"){ return rge }
    if (uf == "rs" && municipio == "tres coroas"){ return rge }
    if (uf == "rs" && municipio == "tres de maio"){ return rge }
    if (uf == "rs" && municipio == "tres palmeiras"){ return rge }
    if (uf == "rs" && municipio == "tres passos"){ return rge }
    if (uf == "rs" && municipio == "trindade do sul"){ return rge }
    if (uf == "rs" && municipio == "triunfo"){ return rge_sul }
    if (uf == "rs" && municipio == "tucunduva"){ return rge }
    if (uf == "rs" && municipio == "tunas"){ return rge_sul }
    if (uf == "rs" && municipio == "tupanci do sul"){ return rge }
    if (uf == "rs" && municipio == "tupancireta"){ return rge }
    if (uf == "rs" && municipio == "tupandi"){ return rge_sul }
    if (uf == "rs" && municipio == "tuparendi"){ return rge }
    if (uf == "rs" && municipio == "ubiretama"){ return rge }
    if (uf == "rs" && municipio == "uniao da serra"){ return rge }
    if (uf == "rs" && municipio == "unistalda"){ return rge_sul }
    if (uf == "rs" && municipio == "uruguaiana"){ return rge_sul }
    if (uf == "rs" && municipio == "vacaria"){ return rge }
    if (uf == "rs" && municipio == "vale do sol"){ return rge_sul }
    if (uf == "rs" && municipio == "vale real"){ return rge }
    if (uf == "rs" && municipio == "vale verde"){ return rge_sul }
    if (uf == "rs" && municipio == "vanini"){ return rge }
    if (uf == "rs" && municipio == "venancio aires"){ return rge_sul }
    if (uf == "rs" && municipio == "vera cruz"){ return rge_sul }
    if (uf == "rs" && municipio == "veranopolis"){ return rge }
    if (uf == "rs" && municipio == "vespasiano correa"){ return rge_sul }
    if (uf == "rs" && municipio == "viadutos"){ return rge }
    if (uf == "rs" && municipio == "vicente dutra"){ return rge }
    if (uf == "rs" && municipio == "victor graeff"){ return rge }
    if (uf == "rs" && municipio == "vila flores"){ return rge }
    if (uf == "rs" && municipio == "vila maria"){ return rge }
    if (uf == "rs" && municipio == "vila nova do sul"){ return rge_sul }
    if (uf == "rs" && municipio == "vista alegre"){ return rge }
    if (uf == "rs" && municipio == "vista alegre do prata"){ return rge }
    if (uf == "rs" && municipio == "vista gaucha"){ return rge }
    if (uf == "rs" && municipio == "vitoria das missoes"){ return rge }
    if (uf == "pr" && municipio == "ribeirão claro"){ return cpfl_santa_cruz }
    if (uf == "ba" && municipio == "abaira"){ return rge_sul }
    if (uf == "ba" && municipio == "abare"){ return rge_sul }
    if (uf == "ba" && municipio == "acajutiba"){ return rge_sul }
    if (uf == "ba" && municipio == "adustina"){ return rge_sul }
    if (uf == "ba" && municipio == "agua fria"){ return rge_sul }
    if (uf == "ba" && municipio == "aiquara"){ return rge_sul }
    if (uf == "ba" && municipio == "alagoinhas"){ return rge_sul }
    if (uf == "ba" && municipio == "alcobaca"){ return rge_sul }
    if (uf == "ba" && municipio == "almadina"){ return rge_sul }
    if (uf == "ba" && municipio == "amargosa"){ return rge_sul }
    if (uf == "ba" && municipio == "amelia rodrigues"){ return rge_sul }
    if (uf == "ba" && municipio == "america dourada"){ return rge_sul }
    if (uf == "ba" && municipio == "anage"){ return rge_sul }
    if (uf == "ba" && municipio == "andarai"){ return rge_sul }
    if (uf == "ba" && municipio == "andorinha"){ return rge_sul }
    if (uf == "ba" && municipio == "angical"){ return rge_sul }
    if (uf == "ba" && municipio == "anguera"){ return rge_sul }
    if (uf == "ba" && municipio == "antas"){ return rge_sul }
    if (uf == "ba" && municipio == "antonio cardoso"){ return rge_sul }
    if (uf == "ba" && municipio == "antonio goncalves"){ return rge_sul }
    if (uf == "ba" && municipio == "apora"){ return rge_sul }
    if (uf == "ba" && municipio == "apuarema"){ return rge_sul }
    if (uf == "ba" && municipio == "aracas"){ return rge_sul }
    if (uf == "ba" && municipio == "aracatu"){ return rge_sul }
    if (uf == "ba" && municipio == "araci"){ return rge_sul }
    if (uf == "ba" && municipio == "aramari"){ return rge_sul }
    if (uf == "ba" && municipio == "arataca"){ return rge_sul }
    if (uf == "ba" && municipio == "aratuipe"){ return rge_sul }
    if (uf == "ba" && municipio == "aurelino leal"){ return rge_sul }
    if (uf == "ba" && municipio == "baianopolis"){ return rge_sul }
    if (uf == "ba" && municipio == "baixa grande"){ return rge_sul }
    if (uf == "ba" && municipio == "banzae"){ return rge_sul }
    if (uf == "ba" && municipio == "barra"){ return rge_sul }
    if (uf == "ba" && municipio == "barra da estiva"){ return rge_sul }
    if (uf == "ba" && municipio == "barra do choca"){ return rge_sul }
    if (uf == "ba" && municipio == "barra do mendes"){ return rge_sul }
    if (uf == "ba" && municipio == "barra do rocha"){ return rge_sul }
    if (uf == "ba" && municipio == "barreiras"){ return rge_sul }
    if (uf == "ba" && municipio == "barro alto"){ return rge_sul }
    if (uf == "ba" && municipio == "barro preto"){ return rge_sul }
    if (uf == "ba" && municipio == "barrocas"){ return rge_sul }
    if (uf == "ba" && municipio == "belmonte"){ return rge_sul }
    if (uf == "ba" && municipio == "belo campo"){ return rge_sul }
    if (uf == "ba" && municipio == "biritinga"){ return rge_sul }
    if (uf == "ba" && municipio == "boa nova"){ return rge_sul }
    if (uf == "ba" && municipio == "boa vista do tupim"){ return rge_sul }
    if (uf == "ba" && municipio == "bom jesus da lapa"){ return rge_sul }
    if (uf == "ba" && municipio == "bom jesus da serra"){ return rge_sul }
    if (uf == "ba" && municipio == "boninal"){ return rge_sul }
    if (uf == "ba" && municipio == "bonito"){ return rge_sul }
    if (uf == "ba" && municipio == "boquira"){ return rge_sul }
    if (uf == "ba" && municipio == "botupora"){ return rge_sul }
    if (uf == "ba" && municipio == "brejoes"){ return rge_sul }
    if (uf == "ba" && municipio == "brejolandia"){ return rge_sul }
    if (uf == "ba" && municipio == "brotas de macaubas"){ return rge_sul }
    if (uf == "ba" && municipio == "brumado"){ return rge_sul }
    if (uf == "ba" && municipio == "buerarema"){ return rge_sul }
    if (uf == "ba" && municipio == "buritirama"){ return rge_sul }
    if (uf == "ba" && municipio == "caatiba"){ return rge_sul }
    if (uf == "ba" && municipio == "cabaceiras do paraguacu"){ return rge_sul }
    if (uf == "ba" && municipio == "cachoeira"){ return rge_sul }
    if (uf == "ba" && municipio == "cacule"){ return rge_sul }
    if (uf == "ba" && municipio == "caem"){ return rge_sul }
    if (uf == "ba" && municipio == "caetanos"){ return rge_sul }
    if (uf == "ba" && municipio == "caetite"){ return rge_sul }
    if (uf == "ba" && municipio == "cafarnaum"){ return rge_sul }
    if (uf == "ba" && municipio == "cairu"){ return rge_sul }
    if (uf == "ba" && municipio == "caldeirao grande"){ return rge_sul }
    if (uf == "ba" && municipio == "camacan"){ return rge_sul }
    if (uf == "ba" && municipio == "camacari"){ return rge_sul }
    if (uf == "ba" && municipio == "camamu"){ return rge_sul }
    if (uf == "ba" && municipio == "campo alegre de lourdes"){ return rge_sul }
    if (uf == "ba" && municipio == "campo formoso"){ return rge_sul }
    if (uf == "ba" && municipio == "canapolis"){ return rge_sul }
    if (uf == "ba" && municipio == "canarana"){ return rge_sul }
    if (uf == "ba" && municipio == "canavieiras"){ return rge_sul }
    if (uf == "ba" && municipio == "candeal"){ return rge_sul }
    if (uf == "ba" && municipio == "candeias"){ return rge_sul }
    if (uf == "ba" && municipio == "candiba"){ return rge_sul }
    if (uf == "ba" && municipio == "candido sales"){ return rge_sul }
    if (uf == "ba" && municipio == "cansancao"){ return rge_sul }
    if (uf == "ba" && municipio == "canudos"){ return rge_sul }
    if (uf == "ba" && municipio == "capela do alto alegre"){ return rge_sul }
    if (uf == "ba" && municipio == "capim grosso"){ return rge_sul }
    if (uf == "ba" && municipio == "caraibas"){ return rge_sul }
    if (uf == "ba" && municipio == "caravelas"){ return rge_sul }
    if (uf == "ba" && municipio == "cardeal da silva"){ return rge_sul }
    if (uf == "ba" && municipio == "carinhanha"){ return rge_sul }
    if (uf == "ba" && municipio == "casa nova"){ return rge_sul }
    if (uf == "ba" && municipio == "castro alves"){ return rge_sul }
    if (uf == "ba" && municipio == "catolandia"){ return rge_sul }
    if (uf == "ba" && municipio == "catu"){ return rge_sul }
    if (uf == "ba" && municipio == "caturama"){ return rge_sul }
    if (uf == "ba" && municipio == "central"){ return rge_sul }
    if (uf == "ba" && municipio == "chorrocho"){ return rge_sul }
    if (uf == "ba" && municipio == "cicero dantas"){ return rge_sul }
    if (uf == "ba" && municipio == "cipo"){ return rge_sul }
    if (uf == "ba" && municipio == "coaraci"){ return rge_sul }
    if (uf == "ba" && municipio == "cocos"){ return rge_sul }
    if (uf == "ba" && municipio == "conceicao da feira"){ return rge_sul }
    if (uf == "ba" && municipio == "conceicao do almeida"){ return rge_sul }
    if (uf == "ba" && municipio == "conceicao do coite"){ return rge_sul }
    if (uf == "ba" && municipio == "conceicao do jacuipe"){ return rge_sul }
    if (uf == "ba" && municipio == "conde"){ return rge_sul }
    if (uf == "ba" && municipio == "condeuba"){ return rge_sul }
    if (uf == "ba" && municipio == "contendas do sincora"){ return rge_sul }
    if (uf == "ba" && municipio == "coracao de maria"){ return rge_sul }
    if (uf == "ba" && municipio == "cordeiros"){ return rge_sul }
    if (uf == "ba" && municipio == "coribe"){ return rge_sul }
    if (uf == "ba" && municipio == "coronel joao sa"){ return rge_sul }
    if (uf == "ba" && municipio == "correntina"){ return rge_sul }
    if (uf == "ba" && municipio == "cotegipe"){ return rge_sul }
    if (uf == "ba" && municipio == "cravolandia"){ return rge_sul }
    if (uf == "ba" && municipio == "crisopolis"){ return rge_sul }
    if (uf == "ba" && municipio == "cristopolis"){ return rge_sul }
    if (uf == "ba" && municipio == "cruz das almas"){ return rge_sul }
    if (uf == "ba" && municipio == "curaca"){ return rge_sul }
    if (uf == "ba" && municipio == "dario meira"){ return rge_sul }
    if (uf == "ba" && municipio == "dias d avila"){ return rge_sul }
    if (uf == "ba" && municipio == "dom basilio"){ return rge_sul }
    if (uf == "ba" && municipio == "dom macedo costa"){ return rge_sul }
    if (uf == "ba" && municipio == "elisio medrado"){ return rge_sul }
    if (uf == "ba" && municipio == "encruzilhada"){ return rge_sul }
    if (uf == "ba" && municipio == "entre rios"){ return rge_sul }
    if (uf == "ba" && municipio == "erico cardoso"){ return rge_sul }
    if (uf == "ba" && municipio == "esplanada"){ return rge_sul }
    if (uf == "ba" && municipio == "euclides da cunha"){ return rge_sul }
    if (uf == "ba" && municipio == "eunapolis"){ return rge_sul }
    if (uf == "ba" && municipio == "fatima"){ return rge_sul }
    if (uf == "ba" && municipio == "feira da mata"){ return rge_sul }
    if (uf == "ba" && municipio == "feira de santana"){ return rge_sul }
    if (uf == "ba" && municipio == "filadelfia"){ return rge_sul }
    if (uf == "ba" && municipio == "firmino alves"){ return rge_sul }
    if (uf == "ba" && municipio == "floresta azul"){ return rge_sul }
    if (uf == "ba" && municipio == "formosa do rio preto"){ return rge_sul }
    if (uf == "ba" && municipio == "gandu"){ return rge_sul }
    if (uf == "ba" && municipio == "gaviao"){ return rge_sul }
    if (uf == "ba" && municipio == "gentio do ouro"){ return rge_sul }
    if (uf == "ba" && municipio == "gloria"){ return rge_sul }
    if (uf == "ba" && municipio == "gongogi"){ return rge_sul }
    if (uf == "ba" && municipio == "governador mangabeira"){ return rge_sul }
    if (uf == "ba" && municipio == "guajeru"){ return rge_sul }
    if (uf == "ba" && municipio == "guanambi"){ return rge_sul }
    if (uf == "ba" && municipio == "guaratinga"){ return rge_sul }
    if (uf == "ba" && municipio == "heliopolis"){ return rge_sul }
    if (uf == "ba" && municipio == "iacu"){ return rge_sul }
    if (uf == "ba" && municipio == "ibiassuce"){ return rge_sul }
    if (uf == "ba" && municipio == "ibicarai"){ return rge_sul }
    if (uf == "ba" && municipio == "ibicoara"){ return rge_sul }
    if (uf == "ba" && municipio == "ibicui"){ return rge_sul }
    if (uf == "ba" && municipio == "ibipeba"){ return rge_sul }
    if (uf == "ba" && municipio == "ibipitanga"){ return rge_sul }
    if (uf == "ba" && municipio == "ibiquera"){ return rge_sul }
    if (uf == "ba" && municipio == "ibirapitanga"){ return rge_sul }
    if (uf == "ba" && municipio == "ibirapua"){ return rge_sul }
    if (uf == "ba" && municipio == "ibirataia"){ return rge_sul }
    if (uf == "ba" && municipio == "ibitiara"){ return rge_sul }
    if (uf == "ba" && municipio == "ibitita"){ return rge_sul }
    if (uf == "ba" && municipio == "ibotirama"){ return rge_sul }
    if (uf == "ba" && municipio == "ichu"){ return rge_sul }
    if (uf == "ba" && municipio == "igapora"){ return rge_sul }
    if (uf == "ba" && municipio == "igrapiuna"){ return rge_sul }
    if (uf == "ba" && municipio == "iguai"){ return rge_sul }
    if (uf == "ba" && municipio == "ilheus"){ return rge_sul }
    if (uf == "ba" && municipio == "inhambupe"){ return rge_sul }
    if (uf == "ba" && municipio == "ipecaeta"){ return rge_sul }
    if (uf == "ba" && municipio == "ipiau"){ return rge_sul }
    if (uf == "ba" && municipio == "ipira"){ return rge_sul }
    if (uf == "ba" && municipio == "ipupiara"){ return rge_sul }
    if (uf == "ba" && municipio == "irajuba"){ return rge_sul }
    if (uf == "ba" && municipio == "iramaia"){ return rge_sul }
    if (uf == "ba" && municipio == "iraquara"){ return rge_sul }
    if (uf == "ba" && municipio == "irara"){ return rge_sul }
    if (uf == "ba" && municipio == "irece"){ return rge_sul }
    if (uf == "ba" && municipio == "itabela"){ return rge_sul }
    if (uf == "ba" && municipio == "itaberaba"){ return rge_sul }
    if (uf == "ba" && municipio == "itabuna"){ return rge_sul }
    if (uf == "ba" && municipio == "itacare"){ return rge_sul }
    if (uf == "ba" && municipio == "itaete"){ return rge_sul }
    if (uf == "ba" && municipio == "itagi"){ return rge_sul }
    if (uf == "ba" && municipio == "itagiba"){ return rge_sul }
    if (uf == "ba" && municipio == "itagimirim"){ return rge_sul }
    if (uf == "ba" && municipio == "itaguacu da bahia"){ return rge_sul }
    if (uf == "ba" && municipio == "itaju do colonia"){ return rge_sul }
    if (uf == "ba" && municipio == "itajuipe"){ return rge_sul }
    if (uf == "ba" && municipio == "itamaraju"){ return rge_sul }
    if (uf == "ba" && municipio == "itamari"){ return rge_sul }
    if (uf == "ba" && municipio == "itambe"){ return rge_sul }
    if (uf == "ba" && municipio == "itanagra"){ return rge_sul }
    if (uf == "ba" && municipio == "itanhem"){ return rge_sul }
    if (uf == "ba" && municipio == "itaparica"){ return rge_sul }
    if (uf == "ba" && municipio == "itape"){ return rge_sul }
    if (uf == "ba" && municipio == "itapebi"){ return rge_sul }
    if (uf == "ba" && municipio == "itapetinga"){ return rge_sul }
    if (uf == "ba" && municipio == "itapicuru"){ return rge_sul }
    if (uf == "ba" && municipio == "itapitanga"){ return rge_sul }
    if (uf == "ba" && municipio == "itaquara"){ return rge_sul }
    if (uf == "ba" && municipio == "itarantim"){ return rge_sul }
    if (uf == "ba" && municipio == "itatim"){ return rge_sul }
    if (uf == "ba" && municipio == "itirucu"){ return rge_sul }
    if (uf == "ba" && municipio == "itiuba"){ return rge_sul }
    if (uf == "ba" && municipio == "itororo"){ return rge_sul }
    if (uf == "ba" && municipio == "ituacu"){ return rge_sul }
    if (uf == "ba" && municipio == "itubera"){ return rge_sul }
    if (uf == "ba" && municipio == "iuiu"){ return rge_sul }
    if (uf == "ba" && municipio == "jaborandi"){ return rge_sul }
    if (uf == "ba" && municipio == "jacaraci"){ return rge_sul }
    if (uf == "ba" && municipio == "jacobina"){ return rge_sul }
    if (uf == "ba" && municipio == "jaguaquara"){ return rge_sul }
    if (uf == "ba" && municipio == "jaguarari"){ return rge_sul }
    if (uf == "ba" && municipio == "jaguaripe"){ return rge_sul }
    if (uf == "ba" && municipio == "jequie"){ return rge_sul }
    if (uf == "ba" && municipio == "jeremoabo"){ return rge_sul }
    if (uf == "ba" && municipio == "jiquirica"){ return rge_sul }
    if (uf == "ba" && municipio == "jitauna"){ return rge_sul }
    if (uf == "ba" && municipio == "joao dourado"){ return rge_sul }
    if (uf == "ba" && municipio == "juazeiro"){ return rge_sul }
    if (uf == "ba" && municipio == "jucurucu"){ return rge_sul }
    if (uf == "ba" && municipio == "jussara"){ return rge_sul }
    if (uf == "ba" && municipio == "jussari"){ return rge_sul }
    if (uf == "ba" && municipio == "jussiape"){ return rge_sul }
    if (uf == "ba" && municipio == "lafaiete coutinho"){ return rge_sul }
    if (uf == "ba" && municipio == "lagoa real"){ return rge_sul }
    if (uf == "ba" && municipio == "laje"){ return rge_sul }
    if (uf == "ba" && municipio == "lajedao"){ return rge_sul }
    if (uf == "ba" && municipio == "lajedinho"){ return rge_sul }
    if (uf == "ba" && municipio == "lajedo do tabocal"){ return rge_sul }
    if (uf == "ba" && municipio == "lamarao"){ return rge_sul }
    if (uf == "ba" && municipio == "lapao"){ return rge_sul }
    if (uf == "ba" && municipio == "lauro de freitas"){ return rge_sul }
    if (uf == "ba" && municipio == "lencois"){ return rge_sul }
    if (uf == "ba" && municipio == "licinio de almeida"){ return rge_sul }
    if (uf == "ba" && municipio == "livramento de nossa senhora"){ return rge_sul }
    if (uf == "ba" && municipio == "luis eduardo magalhaes"){ return rge_sul }
    if (uf == "ba" && municipio == "macajuba"){ return rge_sul }
    if (uf == "ba" && municipio == "macarani"){ return rge_sul }
    if (uf == "ba" && municipio == "macaubas"){ return rge_sul }
    if (uf == "ba" && municipio == "macurure"){ return rge_sul }
    if (uf == "ba" && municipio == "madre de deus"){ return rge_sul }
    if (uf == "ba" && municipio == "maetinga"){ return rge_sul }
    if (uf == "ba" && municipio == "maiquinique"){ return rge_sul }
    if (uf == "ba" && municipio == "mairi"){ return rge_sul }
    if (uf == "ba" && municipio == "malhada"){ return rge_sul }
    if (uf == "ba" && municipio == "malhada de pedras"){ return rge_sul }
    if (uf == "ba" && municipio == "manoel vitorino"){ return rge_sul }
    if (uf == "ba" && municipio == "mansidao"){ return rge_sul }
    if (uf == "ba" && municipio == "maracas"){ return rge_sul }
    if (uf == "ba" && municipio == "maragogipe"){ return rge_sul }
    if (uf == "ba" && municipio == "marau"){ return rge_sul }
    if (uf == "ba" && municipio == "marcionilio souza"){ return rge_sul }
    if (uf == "ba" && municipio == "mascote"){ return rge_sul }
    if (uf == "ba" && municipio == "mata de sao joao"){ return rge_sul }
    if (uf == "ba" && municipio == "matina"){ return rge_sul }
    if (uf == "ba" && municipio == "medeiros neto"){ return rge_sul }
    if (uf == "ba" && municipio == "miguel calmon"){ return rge_sul }
    if (uf == "ba" && municipio == "milagres"){ return rge_sul }
    if (uf == "ba" && municipio == "mirangaba"){ return rge_sul }
    if (uf == "ba" && municipio == "mirante"){ return rge_sul }
    if (uf == "ba" && municipio == "monte santo"){ return rge_sul }
    if (uf == "ba" && municipio == "morpara"){ return rge_sul }
    if (uf == "ba" && municipio == "morro do chapeu"){ return rge_sul }
    if (uf == "ba" && municipio == "mortugaba"){ return rge_sul }
    if (uf == "ba" && municipio == "mucuge"){ return rge_sul }
    if (uf == "ba" && municipio == "mucuri"){ return rge_sul }
    if (uf == "ba" && municipio == "mulungu do morro"){ return rge_sul }
    if (uf == "ba" && municipio == "mundo novo"){ return rge_sul }
    if (uf == "ba" && municipio == "muniz ferreira"){ return rge_sul }
    if (uf == "ba" && municipio == "muquem do sao francisco"){ return rge_sul }
    if (uf == "ba" && municipio == "muritiba"){ return rge_sul }
    if (uf == "ba" && municipio == "mutuipe"){ return rge_sul }
    if (uf == "ba" && municipio == "nazare"){ return rge_sul }
    if (uf == "ba" && municipio == "nilo pecanha"){ return rge_sul }
    if (uf == "ba" && municipio == "nordestina"){ return rge_sul }
    if (uf == "ba" && municipio == "nova canaa"){ return rge_sul }
    if (uf == "ba" && municipio == "nova fatima"){ return rge_sul }
    if (uf == "ba" && municipio == "nova ibia"){ return rge_sul }
    if (uf == "ba" && municipio == "nova itarana"){ return rge_sul }
    if (uf == "ba" && municipio == "nova redencao"){ return rge_sul }
    if (uf == "ba" && municipio == "nova soure"){ return rge_sul }
    if (uf == "ba" && municipio == "nova vicosa"){ return rge_sul }
    if (uf == "ba" && municipio == "novo horizonte"){ return rge_sul }
    if (uf == "ba" && municipio == "novo triunfo"){ return rge_sul }
    if (uf == "ba" && municipio == "olindina"){ return rge_sul }
    if (uf == "ba" && municipio == "oliveira dos brejinhos"){ return rge_sul }
    if (uf == "ba" && municipio == "ouricangas"){ return rge_sul }
    if (uf == "ba" && municipio == "ourolandia"){ return rge_sul }
    if (uf == "ba" && municipio == "palmas de monte alto"){ return rge_sul }
    if (uf == "ba" && municipio == "palmeiras"){ return rge_sul }
    if (uf == "ba" && municipio == "paramirim"){ return rge_sul }
    if (uf == "ba" && municipio == "paratinga"){ return rge_sul }
    if (uf == "ba" && municipio == "paripiranga"){ return rge_sul }
    if (uf == "ba" && municipio == "pau brasil"){ return rge_sul }
    if (uf == "ba" && municipio == "paulo afonso"){ return rge_sul }
    if (uf == "ba" && municipio == "pe de serra"){ return rge_sul }
    if (uf == "ba" && municipio == "pedrao"){ return rge_sul }
    if (uf == "ba" && municipio == "pedro alexandre"){ return rge_sul }
    if (uf == "ba" && municipio == "piata"){ return rge_sul }
    if (uf == "ba" && municipio == "pilao arcado"){ return rge_sul }
    if (uf == "ba" && municipio == "pindai"){ return rge_sul }
    if (uf == "ba" && municipio == "pindobacu"){ return rge_sul }
    if (uf == "ba" && municipio == "pintadas"){ return rge_sul }
    if (uf == "ba" && municipio == "pirai do norte"){ return rge_sul }
    if (uf == "ba" && municipio == "piripa"){ return rge_sul }
    if (uf == "ba" && municipio == "piritiba"){ return rge_sul }
    if (uf == "ba" && municipio == "planaltino"){ return rge_sul }
    if (uf == "ba" && municipio == "planalto"){ return rge_sul }
    if (uf == "ba" && municipio == "pocoes"){ return rge_sul }
    if (uf == "ba" && municipio == "pojuca"){ return rge_sul }
    if (uf == "ba" && municipio == "ponto novo"){ return rge_sul }
    if (uf == "ba" && municipio == "porto seguro"){ return rge_sul }
    if (uf == "ba" && municipio == "potiragua"){ return rge_sul }
    if (uf == "ba" && municipio == "prado"){ return rge_sul }
    if (uf == "ba" && municipio == "presidente dutra"){ return rge_sul }
    if (uf == "ba" && municipio == "presidente janio quadros"){ return rge_sul }
    if (uf == "ba" && municipio == "presidente tancredo neves"){ return rge_sul }
    if (uf == "ba" && municipio == "queimadas"){ return rge_sul }
    if (uf == "ba" && municipio == "quijingue"){ return rge_sul }
    if (uf == "ba" && municipio == "quixabeira"){ return rge_sul }
    if (uf == "ba" && municipio == "rafael jambeiro"){ return rge_sul }
    if (uf == "ba" && municipio == "remanso"){ return rge_sul }
    if (uf == "ba" && municipio == "retirolandia"){ return rge_sul }
    if (uf == "ba" && municipio == "riachao das neves"){ return rge_sul }
    if (uf == "ba" && municipio == "riachao do jacuipe"){ return rge_sul }
    if (uf == "ba" && municipio == "riacho de santana"){ return rge_sul }
    if (uf == "ba" && municipio == "ribeira do amparo"){ return rge_sul }
    if (uf == "ba" && municipio == "ribeira do pombal"){ return rge_sul }
    if (uf == "ba" && municipio == "ribeirao do largo"){ return rge_sul }
    if (uf == "ba" && municipio == "rio de contas"){ return rge_sul }
    if (uf == "ba" && municipio == "rio do antonio"){ return rge_sul }
    if (uf == "ba" && municipio == "rio do pires"){ return rge_sul }
    if (uf == "ba" && municipio == "rodelas"){ return rge_sul }
    if (uf == "ba" && municipio == "ruy barbosa"){ return rge_sul }
    if (uf == "ba" && municipio == "salinas da margarida"){ return rge_sul }
    if (uf == "ba" && municipio == "salvador"){ return rge_sul }
    if (uf == "ba" && municipio == "santa barbara"){ return rge_sul }
    if (uf == "ba" && municipio == "santa brigida"){ return rge_sul }
    if (uf == "ba" && municipio == "santa cruz cabralia"){ return rge_sul }
    if (uf == "ba" && municipio == "santa cruz da vitoria"){ return rge_sul }
    if (uf == "ba" && municipio == "santa ines"){ return rge_sul }
    if (uf == "ba" && municipio == "santa luzia"){ return rge_sul }
    if (uf == "ba" && municipio == "santa maria da vitoria"){ return rge_sul }
    if (uf == "ba" && municipio == "santa rita de cassia"){ return rge_sul }
    if (uf == "ba" && municipio == "santa terezinha"){ return rge_sul }
    if (uf == "ba" && municipio == "santaluz"){ return rge_sul }
    if (uf == "ba" && municipio == "santana"){ return rge_sul }
    if (uf == "ba" && municipio == "santanopolis"){ return rge_sul }
    if (uf == "ba" && municipio == "santo amaro"){ return rge_sul }
    if (uf == "ba" && municipio == "santo antonio de jesus"){ return rge_sul }
    if (uf == "ba" && municipio == "santo estevao"){ return rge_sul }
    if (uf == "ba" && municipio == "sao desiderio"){ return rge_sul }
    if (uf == "ba" && municipio == "sao domingos"){ return rge_sul }
    if (uf == "ba" && municipio == "sao felipe"){ return rge_sul }
    if (uf == "ba" && municipio == "sao felix"){ return rge_sul }
    if (uf == "ba" && municipio == "sao felix do coribe"){ return rge_sul }
    if (uf == "ba" && municipio == "sao francisco do conde"){ return rge_sul }
    if (uf == "ba" && municipio == "sao gabriel"){ return rge_sul }
    if (uf == "ba" && municipio == "sao goncalo dos campos"){ return rge_sul }
    if (uf == "ba" && municipio == "sao jose da vitoria"){ return rge_sul }
    if (uf == "ba" && municipio == "sao jose do jacuipe"){ return rge_sul }
    if (uf == "ba" && municipio == "sao miguel das matas"){ return rge_sul }
    if (uf == "ba" && municipio == "sao sebastiao do passe"){ return rge_sul }
    if (uf == "ba" && municipio == "sapeacu"){ return rge_sul }
    if (uf == "ba" && municipio == "satiro dias"){ return rge_sul }
    if (uf == "ba" && municipio == "saubara"){ return rge_sul }
    if (uf == "ba" && municipio == "saude"){ return rge_sul }
    if (uf == "ba" && municipio == "seabra"){ return rge_sul }
    if (uf == "ba" && municipio == "sebastiao laranjeiras"){ return rge_sul }
    if (uf == "ba" && municipio == "senhor do bonfim"){ return rge_sul }
    if (uf == "ba" && municipio == "sento se"){ return rge_sul }
    if (uf == "ba" && municipio == "serra do ramalho"){ return rge_sul }
    if (uf == "ba" && municipio == "serra dourada"){ return rge_sul }
    if (uf == "ba" && municipio == "serra preta"){ return rge_sul }
    if (uf == "ba" && municipio == "serrinha"){ return rge_sul }
    if (uf == "ba" && municipio == "serrolandia"){ return rge_sul }
    if (uf == "ba" && municipio == "simoes filho"){ return rge_sul }
    if (uf == "ba" && municipio == "sitio do mato"){ return rge_sul }
    if (uf == "ba" && municipio == "sitio do quinto"){ return rge_sul }
    if (uf == "ba" && municipio == "sobradinho"){ return rge_sul }
    if (uf == "ba" && municipio == "souto soares"){ return rge_sul }
    if (uf == "ba" && municipio == "tabocas do brejo velho"){ return rge_sul }
    if (uf == "ba" && municipio == "tanhacu"){ return rge_sul }
    if (uf == "ba" && municipio == "tanque novo"){ return rge_sul }
    if (uf == "ba" && municipio == "tanquinho"){ return rge_sul }
    if (uf == "ba" && municipio == "taperoa"){ return rge_sul }
    if (uf == "ba" && municipio == "tapiramuta"){ return rge_sul }
    if (uf == "ba" && municipio == "teixeira de freitas"){ return rge_sul }
    if (uf == "ba" && municipio == "teodoro sampaio"){ return rge_sul }
    if (uf == "ba" && municipio == "teofilandia"){ return rge_sul }
    if (uf == "ba" && municipio == "teolandia"){ return rge_sul }
    if (uf == "ba" && municipio == "terra nova"){ return rge_sul }
    if (uf == "ba" && municipio == "tremedal"){ return rge_sul }
    if (uf == "ba" && municipio == "tucano"){ return rge_sul }
    if (uf == "ba" && municipio == "uaua"){ return rge_sul }
    if (uf == "ba" && municipio == "ubaira"){ return rge_sul }
    if (uf == "ba" && municipio == "ubaitaba"){ return rge_sul }
    if (uf == "ba" && municipio == "ubata"){ return rge_sul }
    if (uf == "ba" && municipio == "uibai"){ return rge_sul }
    if (uf == "ba" && municipio == "umburanas"){ return rge_sul }
    if (uf == "ba" && municipio == "una"){ return rge_sul }
    if (uf == "ba" && municipio == "urandi"){ return rge_sul }
    if (uf == "ba" && municipio == "urucuca"){ return rge_sul }
    if (uf == "ba" && municipio == "utinga"){ return rge_sul }
    if (uf == "ba" && municipio == "valenca"){ return rge_sul }
    if (uf == "ba" && municipio == "valente"){ return rge_sul }
    if (uf == "ba" && municipio == "varzea da roca"){ return rge_sul }
    if (uf == "ba" && municipio == "varzea do poco"){ return rge_sul }
    if (uf == "ba" && municipio == "varzea nova"){ return rge_sul }
    if (uf == "ba" && municipio == "varzedo"){ return rge_sul }
    if (uf == "ba" && municipio == "vera cruz"){ return rge_sul }
    if (uf == "ba" && municipio == "vereda"){ return rge_sul }
    if (uf == "ba" && municipio == "vitoria da conquista"){ return rge_sul }
    if (uf == "ba" && municipio == "wagner"){ return rge_sul }
    if (uf == "ba" && municipio == "wanderley"){ return rge_sul }
    if (uf == "ba" && municipio == "wenceslau guimaraes"){ return rge_sul }
    if (uf == "ba" && municipio == "xique-xique"){ return rge_sul }
    if (uf == "rn" && municipio == "acari"){ return cosern }
    if (uf == "rn" && municipio == "acu"){ return cosern }
    if (uf == "rn" && municipio == "afonso bezerra"){ return cosern }
    if (uf == "rn" && municipio == "agua nova"){ return cosern }
    if (uf == "rn" && municipio == "alexandria"){ return cosern }
    if (uf == "rn" && municipio == "almino afonso"){ return cosern }
    if (uf == "rn" && municipio == "alto do rodrigues"){ return cosern }
    if (uf == "rn" && municipio == "angicos"){ return cosern }
    if (uf == "rn" && municipio == "antonio martins"){ return cosern }
    if (uf == "rn" && municipio == "apodi"){ return cosern }
    if (uf == "rn" && municipio == "areia branca"){ return cosern }
    if (uf == "rn" && municipio == "ares"){ return cosern }
    if (uf == "rn" && municipio == "augusto severo"){ return cosern }
    if (uf == "rn" && municipio == "baia formosa"){ return cosern }
    if (uf == "rn" && municipio == "barauna"){ return cosern }
    if (uf == "rn" && municipio == "barcelona"){ return cosern }
    if (uf == "rn" && municipio == "bento fernandes"){ return cosern }
    if (uf == "rn" && municipio == "bodo"){ return cosern }
    if (uf == "rn" && municipio == "bom jesus"){ return cosern }
    if (uf == "rn" && municipio == "brejinho"){ return cosern }
    if (uf == "rn" && municipio == "caicara do norte"){ return cosern }
    if (uf == "rn" && municipio == "caicara do rio do vento"){ return cosern }
    if (uf == "rn" && municipio == "caico"){ return cosern }
    if (uf == "rn" && municipio == "campo redondo"){ return cosern }
    if (uf == "rn" && municipio == "canguaretama"){ return cosern }
    if (uf == "rn" && municipio == "caraubas"){ return cosern }
    if (uf == "rn" && municipio == "carnauba dos dantas"){ return cosern }
    if (uf == "rn" && municipio == "carnaubais"){ return cosern }
    if (uf == "rn" && municipio == "ceara-mirim"){ return cosern }
    if (uf == "rn" && municipio == "cerro cora"){ return cosern }
    if (uf == "rn" && municipio == "coronel ezequiel"){ return cosern }
    if (uf == "rn" && municipio == "coronel joao pessoa"){ return cosern }
    if (uf == "rn" && municipio == "cruzeta"){ return cosern }
    if (uf == "rn" && municipio == "currais novos"){ return cosern }
    if (uf == "rn" && municipio == "doutor severiano"){ return cosern }
    if (uf == "rn" && municipio == "encanto"){ return cosern }
    if (uf == "rn" && municipio == "equador"){ return cosern }
    if (uf == "rn" && municipio == "espirito santo"){ return cosern }
    if (uf == "rn" && municipio == "extremoz"){ return cosern }
    if (uf == "rn" && municipio == "felipe guerra"){ return cosern }
    if (uf == "rn" && municipio == "fernando pedroza"){ return cosern }
    if (uf == "rn" && municipio == "florania"){ return cosern }
    if (uf == "rn" && municipio == "francisco dantas"){ return cosern }
    if (uf == "rn" && municipio == "frutuoso gomes"){ return cosern }
    if (uf == "rn" && municipio == "galinhos"){ return cosern }
    if (uf == "rn" && municipio == "goianinha"){ return cosern }
    if (uf == "rn" && municipio == "governador dix-sept rosado"){ return cosern }
    if (uf == "rn" && municipio == "grossos"){ return cosern }
    if (uf == "rn" && municipio == "guamare"){ return cosern }
    if (uf == "rn" && municipio == "ielmo marinho"){ return cosern }
    if (uf == "rn" && municipio == "ipanguacu"){ return cosern }
    if (uf == "rn" && municipio == "ipueira"){ return cosern }
    if (uf == "rn" && municipio == "itaja"){ return cosern }
    if (uf == "rn" && municipio == "itau"){ return cosern }
    if (uf == "rn" && municipio == "jacana"){ return cosern }
    if (uf == "rn" && municipio == "jandaira"){ return cosern }
    if (uf == "rn" && municipio == "janduis"){ return cosern }
    if (uf == "rn" && municipio == "januario cicco"){ return cosern }
    if (uf == "rn" && municipio == "japi"){ return cosern }
    if (uf == "rn" && municipio == "jardim de angicos"){ return cosern }
    if (uf == "rn" && municipio == "jardim de piranhas"){ return cosern }
    if (uf == "rn" && municipio == "jardim do serido"){ return cosern }
    if (uf == "rn" && municipio == "joao camara"){ return cosern }
    if (uf == "rn" && municipio == "joao dias"){ return cosern }
    if (uf == "rn" && municipio == "jose da penha"){ return cosern }
    if (uf == "rn" && municipio == "jucurutu"){ return cosern }
    if (uf == "rn" && municipio == "jundia"){ return cosern }
    if (uf == "rn" && municipio == "lagoa d anta"){ return cosern }
    if (uf == "rn" && municipio == "lagoa de pedras"){ return cosern }
    if (uf == "rn" && municipio == "lagoa de velhos"){ return cosern }
    if (uf == "rn" && municipio == "lagoa nova"){ return cosern }
    if (uf == "rn" && municipio == "lagoa salgada"){ return cosern }
    if (uf == "rn" && municipio == "lajes"){ return cosern }
    if (uf == "rn" && municipio == "lajes pintadas"){ return cosern }
    if (uf == "rn" && municipio == "lucrecia"){ return cosern }
    if (uf == "rn" && municipio == "luis gomes"){ return cosern }
    if (uf == "rn" && municipio == "macaiba"){ return cosern }
    if (uf == "rn" && municipio == "macau"){ return cosern }
    if (uf == "rn" && municipio == "major sales"){ return cosern }
    if (uf == "rn" && municipio == "marcelino vieira"){ return cosern }
    if (uf == "rn" && municipio == "martins"){ return cosern }
    if (uf == "rn" && municipio == "maxaranguape"){ return cosern }
    if (uf == "rn" && municipio == "messias targino"){ return cosern }
    if (uf == "rn" && municipio == "montanhas"){ return cosern }
    if (uf == "rn" && municipio == "monte alegre"){ return cosern }
    if (uf == "rn" && municipio == "monte das gameleiras"){ return cosern }
    if (uf == "rn" && municipio == "mossoro"){ return cosern }
    if (uf == "rn" && municipio == "natal"){ return cosern }
    if (uf == "rn" && municipio == "nisia floresta"){ return cosern }
    if (uf == "rn" && municipio == "nova cruz"){ return cosern }
    if (uf == "rn" && municipio == "olho d agua do borges"){ return cosern }
    if (uf == "rn" && municipio == "ouro branco"){ return cosern }
    if (uf == "rn" && municipio == "parana"){ return cosern }
    if (uf == "rn" && municipio == "parau"){ return cosern }
    if (uf == "rn" && municipio == "parazinho"){ return cosern }
    if (uf == "rn" && municipio == "parelhas"){ return cosern }
    if (uf == "rn" && municipio == "parnamirim"){ return cosern }
    if (uf == "rn" && municipio == "passa e fica"){ return cosern }
    if (uf == "rn" && municipio == "passagem"){ return cosern }
    if (uf == "rn" && municipio == "patu"){ return cosern }
    if (uf == "rn" && municipio == "pau dos ferros"){ return cosern }
    if (uf == "rn" && municipio == "pedra grande"){ return cosern }
    if (uf == "rn" && municipio == "pedra preta"){ return cosern }
    if (uf == "rn" && municipio == "pedro avelino"){ return cosern }
    if (uf == "rn" && municipio == "pedro velho"){ return cosern }
    if (uf == "rn" && municipio == "pendencias"){ return cosern }
    if (uf == "rn" && municipio == "piloes"){ return cosern }
    if (uf == "rn" && municipio == "poco branco"){ return cosern }
    if (uf == "rn" && municipio == "portalegre"){ return cosern }
    if (uf == "rn" && municipio == "porto do mangue"){ return cosern }
    if (uf == "rn" && municipio == "pureza"){ return cosern }
    if (uf == "rn" && municipio == "rafael fernandes"){ return cosern }
    if (uf == "rn" && municipio == "rafael godeiro"){ return cosern }
    if (uf == "rn" && municipio == "riacho da cruz"){ return cosern }
    if (uf == "rn" && municipio == "riacho de santana"){ return cosern }
    if (uf == "rn" && municipio == "riachuelo"){ return cosern }
    if (uf == "rn" && municipio == "rio do fogo"){ return cosern }
    if (uf == "rn" && municipio == "rodolfo fernandes"){ return cosern }
    if (uf == "rn" && municipio == "ruy barbosa"){ return cosern }
    if (uf == "rn" && municipio == "santa cruz"){ return cosern }
    if (uf == "rn" && municipio == "santa maria"){ return cosern }
    if (uf == "rn" && municipio == "santana do matos"){ return cosern }
    if (uf == "rn" && municipio == "santana do serido"){ return cosern }
    if (uf == "rn" && municipio == "santo antonio"){ return cosern }
    if (uf == "rn" && municipio == "sao bento do norte"){ return cosern }
    if (uf == "rn" && municipio == "sao bento do trairi"){ return cosern }
    if (uf == "rn" && municipio == "sao fernando"){ return cosern }
    if (uf == "rn" && municipio == "sao francisco do oeste"){ return cosern }
    if (uf == "rn" && municipio == "sao goncalo do amarante"){ return cosern }
    if (uf == "rn" && municipio == "sao joao do sabugi"){ return cosern }
    if (uf == "rn" && municipio == "sao jose de mipibu"){ return cosern }
    if (uf == "rn" && municipio == "sao jose do campestre"){ return cosern }
    if (uf == "rn" && municipio == "sao jose do serido"){ return cosern }
    if (uf == "rn" && municipio == "sao miguel"){ return cosern }
    if (uf == "rn" && municipio == "sao miguel do gostoso"){ return cosern }
    if (uf == "rn" && municipio == "sao paulo do potengi"){ return cosern }
    if (uf == "rn" && municipio == "sao pedro"){ return cosern }
    if (uf == "rn" && municipio == "sao rafael"){ return cosern }
    if (uf == "rn" && municipio == "sao tome"){ return cosern }
    if (uf == "rn" && municipio == "sao vicente"){ return cosern }
    if (uf == "rn" && municipio == "senador eloi de souza"){ return cosern }
    if (uf == "rn" && municipio == "senador georgino avelino"){ return cosern }
    if (uf == "rn" && municipio == "serra caiada"){ return cosern }
    if (uf == "rn" && municipio == "serra de sao bento"){ return cosern }
    if (uf == "rn" && municipio == "serra do mel"){ return cosern }
    if (uf == "rn" && municipio == "serra negra do norte"){ return cosern }
    if (uf == "rn" && municipio == "serrinha"){ return cosern }
    if (uf == "rn" && municipio == "serrinha dos pintos"){ return cosern }
    if (uf == "rn" && municipio == "severiano melo"){ return cosern }
    if (uf == "rn" && municipio == "sitio novo"){ return cosern }
    if (uf == "rn" && municipio == "taboleiro grande"){ return cosern }
    if (uf == "rn" && municipio == "taipu"){ return cosern }
    if (uf == "rn" && municipio == "tangara"){ return cosern }
    if (uf == "rn" && municipio == "tenente ananias"){ return cosern }
    if (uf == "rn" && municipio == "tenente laurentino cruz"){ return cosern }
    if (uf == "rn" && municipio == "tibau"){ return cosern }
    if (uf == "rn" && municipio == "tibau do sul"){ return cosern }
    if (uf == "rn" && municipio == "timbauba dos batistas"){ return cosern }
    if (uf == "rn" && municipio == "touros"){ return cosern }
    if (uf == "rn" && municipio == "triunfo potiguar"){ return cosern }
    if (uf == "rn" && municipio == "umarizal"){ return cosern }
    if (uf == "rn" && municipio == "upanema"){ return cosern }
    if (uf == "rn" && municipio == "varzea"){ return cosern }
    if (uf == "rn" && municipio == "venha-ver"){ return cosern }
    if (uf == "rn" && municipio == "vera cruz"){ return cosern }
    if (uf == "rn" && municipio == "vicosa"){ return cosern }
    if (uf == "rn" && municipio == "vila flor"){ return cosern }
    if (uf == "pe" && municipio == "abreu e lima"){ return celpe }
    if (uf == "pe" && municipio == "afogados da ingazeira"){ return celpe }
    if (uf == "pe" && municipio == "afranio"){ return celpe }
    if (uf == "pe" && municipio == "agrestina"){ return celpe }
    if (uf == "pe" && municipio == "agua preta"){ return celpe }
    if (uf == "pe" && municipio == "aguas belas"){ return celpe }
    if (uf == "pe" && municipio == "alagoinha"){ return celpe }
    if (uf == "pe" && municipio == "alianca"){ return celpe }
    if (uf == "pe" && municipio == "altinho"){ return celpe }
    if (uf == "pe" && municipio == "amaraji"){ return celpe }
    if (uf == "pe" && municipio == "angelim"){ return celpe }
    if (uf == "pe" && municipio == "aracoiaba"){ return celpe }
    if (uf == "pe" && municipio == "araripina"){ return celpe }
    if (uf == "pe" && municipio == "arcoverde"){ return celpe }
    if (uf == "pe" && municipio == "barra de guabiraba"){ return celpe }
    if (uf == "pe" && municipio == "barreiros"){ return celpe }
    if (uf == "pe" && municipio == "belem de maria"){ return celpe }
    if (uf == "pe" && municipio == "belem do sao francisco"){ return celpe }
    if (uf == "pe" && municipio == "belo jardim"){ return celpe }
    if (uf == "pe" && municipio == "betania"){ return celpe }
    if (uf == "pe" && municipio == "bezerros"){ return celpe }
    if (uf == "pe" && municipio == "bodoco"){ return celpe }
    if (uf == "pe" && municipio == "bom conselho"){ return celpe }
    if (uf == "pe" && municipio == "bom jardim"){ return celpe }
    if (uf == "pe" && municipio == "bonito"){ return celpe }
    if (uf == "pe" && municipio == "brejao"){ return celpe }
    if (uf == "pe" && municipio == "brejinho"){ return celpe }
    if (uf == "pe" && municipio == "brejo da madre de deus"){ return celpe }
    if (uf == "pe" && municipio == "buenos aires"){ return celpe }
    if (uf == "pe" && municipio == "buique"){ return celpe }
    if (uf == "pe" && municipio == "cabo de santo agostinho"){ return celpe }
    if (uf == "pe" && municipio == "cabrobo"){ return celpe }
    if (uf == "pe" && municipio == "cachoeirinha"){ return celpe }
    if (uf == "pe" && municipio == "caetes"){ return celpe }
    if (uf == "pe" && municipio == "calcado"){ return celpe }
    if (uf == "pe" && municipio == "calumbi"){ return celpe }
    if (uf == "pe" && municipio == "camaragibe"){ return celpe }
    if (uf == "pe" && municipio == "camocim de sao felix"){ return celpe }
    if (uf == "pe" && municipio == "camutanga"){ return celpe }
    if (uf == "pe" && municipio == "canhotinho"){ return celpe }
    if (uf == "pe" && municipio == "capoeiras"){ return celpe }
    if (uf == "pe" && municipio == "carnaiba"){ return celpe }
    if (uf == "pe" && municipio == "carnaubeira da penha"){ return celpe }
    if (uf == "pe" && municipio == "carpina"){ return celpe }
    if (uf == "pe" && municipio == "caruaru"){ return celpe }
    if (uf == "pe" && municipio == "casinhas"){ return celpe }
    if (uf == "pe" && municipio == "catende"){ return celpe }
    if (uf == "pe" && municipio == "cedro"){ return celpe }
    if (uf == "pe" && municipio == "cha de alegria"){ return celpe }
    if (uf == "pe" && municipio == "cha grande"){ return celpe }
    if (uf == "pe" && municipio == "condado"){ return celpe }
    if (uf == "pe" && municipio == "correntes"){ return celpe }
    if (uf == "pe" && municipio == "cortes"){ return celpe }
    if (uf == "pe" && municipio == "cumaru"){ return celpe }
    if (uf == "pe" && municipio == "cupira"){ return celpe }
    if (uf == "pe" && municipio == "custodia"){ return celpe }
    if (uf == "pe" && municipio == "dormentes"){ return celpe }
    if (uf == "pe" && municipio == "escada"){ return celpe }
    if (uf == "pe" && municipio == "exu"){ return celpe }
    if (uf == "pe" && municipio == "feira nova"){ return celpe }
    if (uf == "pe" && municipio == "fernando de noronha"){ return celpe }
    if (uf == "pe" && municipio == "ferreiros"){ return celpe }
    if (uf == "pe" && municipio == "flores"){ return celpe }
    if (uf == "pe" && municipio == "floresta"){ return celpe }
    if (uf == "pe" && municipio == "frei miguelinho"){ return celpe }
    if (uf == "pe" && municipio == "gameleira"){ return celpe }
    if (uf == "pe" && municipio == "garanhuns"){ return celpe }
    if (uf == "pe" && municipio == "gloria do goita"){ return celpe }
    if (uf == "pe" && municipio == "goiana"){ return celpe }
    if (uf == "pe" && municipio == "granito"){ return celpe }
    if (uf == "pe" && municipio == "gravata"){ return celpe }
    if (uf == "pe" && municipio == "iati"){ return celpe }
    if (uf == "pe" && municipio == "ibimirim"){ return celpe }
    if (uf == "pe" && municipio == "ibirajuba"){ return celpe }
    if (uf == "pe" && municipio == "igarassu"){ return celpe }
    if (uf == "pe" && municipio == "iguaracy"){ return celpe }
    if (uf == "pe" && municipio == "ilha de itamaraca"){ return celpe }
    if (uf == "pe" && municipio == "inaja"){ return celpe }
    if (uf == "pe" && municipio == "ingazeira"){ return celpe }
    if (uf == "pe" && municipio == "ipojuca"){ return celpe }
    if (uf == "pe" && municipio == "ipubi"){ return celpe }
    if (uf == "pe" && municipio == "itacuruba"){ return celpe }
    if (uf == "pe" && municipio == "itaiba"){ return celpe }
    if (uf == "pe" && municipio == "itambe"){ return celpe }
    if (uf == "pe" && municipio == "itapetim"){ return celpe }
    if (uf == "pe" && municipio == "itapissuma"){ return celpe }
    if (uf == "pe" && municipio == "itaquitinga"){ return celpe }
    if (uf == "pe" && municipio == "jaboatao dos guararapes"){ return celpe }
    if (uf == "pe" && municipio == "jaqueira"){ return celpe }
    if (uf == "pe" && municipio == "jatauba"){ return celpe }
    if (uf == "pe" && municipio == "jatoba"){ return celpe }
    if (uf == "pe" && municipio == "joao alfredo"){ return celpe }
    if (uf == "pe" && municipio == "joaquim nabuco"){ return celpe }
    if (uf == "pe" && municipio == "jucati"){ return celpe }
    if (uf == "pe" && municipio == "jupi"){ return celpe }
    if (uf == "pe" && municipio == "jurema"){ return celpe }
    if (uf == "pe" && municipio == "lagoa de itaenga"){ return celpe }
    if (uf == "pe" && municipio == "lagoa do carro"){ return celpe }
    if (uf == "pe" && municipio == "lagoa do ouro"){ return celpe }
    if (uf == "pe" && municipio == "lagoa dos gatos"){ return celpe }
    if (uf == "pe" && municipio == "lagoa grande"){ return celpe }
    if (uf == "pe" && municipio == "lajedo"){ return celpe }
    if (uf == "pe" && municipio == "limoeiro"){ return celpe }
    if (uf == "pe" && municipio == "macaparana"){ return celpe }
    if (uf == "pe" && municipio == "machados"){ return celpe }
    if (uf == "pe" && municipio == "manari"){ return celpe }
    if (uf == "pe" && municipio == "maraial"){ return celpe }
    if (uf == "pe" && municipio == "mirandiba"){ return celpe }
    if (uf == "pe" && municipio == "moreilandia"){ return celpe }
    if (uf == "pe" && municipio == "moreno"){ return celpe }
    if (uf == "pe" && municipio == "nazare da mata"){ return celpe }
    if (uf == "pe" && municipio == "olinda"){ return celpe }
    if (uf == "pe" && municipio == "orobo"){ return celpe }
    if (uf == "pe" && municipio == "oroco"){ return celpe }
    if (uf == "pe" && municipio == "ouricuri"){ return celpe }
    if (uf == "pe" && municipio == "palmares"){ return celpe }
    if (uf == "pe" && municipio == "palmeirina"){ return celpe }
    if (uf == "pe" && municipio == "panelas"){ return celpe }
    if (uf == "pe" && municipio == "paranatama"){ return celpe }
    if (uf == "pe" && municipio == "parnamirim"){ return celpe }
    if (uf == "pe" && municipio == "passira"){ return celpe }
    if (uf == "pe" && municipio == "paudalho"){ return celpe }
    if (uf == "pe" && municipio == "paulista"){ return celpe }
    if (uf == "pe" && municipio == "pedra"){ return celpe }
    if (uf == "pe" && municipio == "pesqueira"){ return celpe }
    if (uf == "pe" && municipio == "petrolandia"){ return celpe }
    if (uf == "pe" && municipio == "petrolina"){ return celpe }
    if (uf == "pe" && municipio == "pocao"){ return celpe }
    if (uf == "pe" && municipio == "pombos"){ return celpe }
    if (uf == "pe" && municipio == "primavera"){ return celpe }
    if (uf == "pe" && municipio == "quipapa"){ return celpe }
    if (uf == "pe" && municipio == "quixaba"){ return celpe }
    if (uf == "pe" && municipio == "recife"){ return celpe }
    if (uf == "pe" && municipio == "riacho das almas"){ return celpe }
    if (uf == "pe" && municipio == "ribeirao"){ return celpe }
    if (uf == "pe" && municipio == "rio formoso"){ return celpe }
    if (uf == "pe" && municipio == "saire"){ return celpe }
    if (uf == "pe" && municipio == "salgadinho"){ return celpe }
    if (uf == "pe" && municipio == "salgueiro"){ return celpe }
    if (uf == "pe" && municipio == "saloa"){ return celpe }
    if (uf == "pe" && municipio == "sanharo"){ return celpe }
    if (uf == "pe" && municipio == "santa cruz"){ return celpe }
    if (uf == "pe" && municipio == "santa cruz da baixa verde"){ return celpe }
    if (uf == "pe" && municipio == "santa cruz do capibaribe"){ return celpe }
    if (uf == "pe" && municipio == "santa filomena"){ return celpe }
    if (uf == "pe" && municipio == "santa maria da boa vista"){ return celpe }
    if (uf == "pe" && municipio == "santa maria do cambuca"){ return celpe }
    if (uf == "pe" && municipio == "santa terezinha"){ return celpe }
    if (uf == "pe" && municipio == "sao benedito do sul"){ return celpe }
    if (uf == "pe" && municipio == "sao bento do una"){ return celpe }
    if (uf == "pe" && municipio == "sao caitano"){ return celpe }
    if (uf == "pe" && municipio == "sao joao"){ return celpe }
    if (uf == "pe" && municipio == "sao joaquim do monte"){ return celpe }
    if (uf == "pe" && municipio == "sao jose da coroa grande"){ return celpe }
    if (uf == "pe" && municipio == "sao jose do belmonte"){ return celpe }
    if (uf == "pe" && municipio == "sao jose do egito"){ return celpe }
    if (uf == "pe" && municipio == "sao lourenco da mata"){ return celpe }
    if (uf == "pe" && municipio == "sao vicente ferrer"){ return celpe }
    if (uf == "pe" && municipio == "serra talhada"){ return celpe }
    if (uf == "pe" && municipio == "serrita"){ return celpe }
    if (uf == "pe" && municipio == "sertania"){ return celpe }
    if (uf == "pe" && municipio == "sirinhaem"){ return celpe }
    if (uf == "pe" && municipio == "solidao"){ return celpe }
    if (uf == "pe" && municipio == "surubim"){ return celpe }
    if (uf == "pe" && municipio == "tabira"){ return celpe }
    if (uf == "pe" && municipio == "tacaimbo"){ return celpe }
    if (uf == "pe" && municipio == "tacaratu"){ return celpe }
    if (uf == "pe" && municipio == "tamandare"){ return celpe }
    if (uf == "pe" && municipio == "taquaritinga do norte"){ return celpe }
    if (uf == "pe" && municipio == "terezinha"){ return celpe }
    if (uf == "pe" && municipio == "terra nova"){ return celpe }
    if (uf == "pe" && municipio == "timbauba"){ return celpe }
    if (uf == "pe" && municipio == "toritama"){ return celpe }
    if (uf == "pe" && municipio == "tracunhaem"){ return celpe }
    if (uf == "pe" && municipio == "trindade"){ return celpe }
    if (uf == "pe" && municipio == "triunfo"){ return celpe }
    if (uf == "pe" && municipio == "tupanatinga"){ return celpe }
    if (uf == "pe" && municipio == "tuparetama"){ return celpe }
    if (uf == "pe" && municipio == "venturosa"){ return celpe }
    if (uf == "pe" && municipio == "verdejante"){ return celpe }
    if (uf == "pe" && municipio == "vertente do lerio"){ return celpe }
    if (uf == "pe" && municipio == "vertentes"){ return celpe }
    if (uf == "pe" && municipio == "vicencia"){ return celpe }
    if (uf == "pe" && municipio == "vitoria de santo antao"){ return celpe }
    if (uf == "pe" && municipio == "xexeu"){ return celpe }
    if (uf == "rn" && municipio == "lagoa salgada"){ return cosern }
    if (uf == "rn" && municipio == "lajes"){ return cosern }
    if (uf == "rn" && municipio == "lajes pintadas"){ return cosern }
    if (uf == "rn" && municipio == "lucrecia"){ return cosern }
    if (uf == "rn" && municipio == "luis gomes"){ return cosern }
    if (uf == "rn" && municipio == "macaiba"){ return cosern }
    if (uf == "rn" && municipio == "macau"){ return cosern }
    if (uf == "rn" && municipio == "major sales"){ return cosern }
    if (uf == "rn" && municipio == "marcelino vieira"){ return cosern }
    if (uf == "rn" && municipio == "martins"){ return cosern }
    if (uf == "rn" && municipio == "maxaranguape"){ return cosern }
    if (uf == "rn" && municipio == "messias targino"){ return cosern }
    if (uf == "rn" && municipio == "montanhas"){ return cosern }
    if (uf == "rn" && municipio == "monte alegre"){ return cosern }
    if (uf == "rn" && municipio == "monte das gameleiras"){ return cosern }
    if (uf == "rn" && municipio == "mossoro"){ return cosern }
    if (uf == "rn" && municipio == "natal"){ return cosern }
    if (uf == "rn" && municipio == "nisia floresta"){ return cosern }
    if (uf == "rn" && municipio == "nova cruz"){ return cosern }
    if (uf == "rn" && municipio == "olho d agua do borges"){ return cosern }
    if (uf == "rn" && municipio == "ouro branco"){ return cosern }
    if (uf == "rn" && municipio == "parana"){ return cosern }
    if (uf == "rn" && municipio == "parau"){ return cosern }
    if (uf == "rn" && municipio == "parazinho"){ return cosern }
    if (uf == "rn" && municipio == "parelhas"){ return cosern }
    if (uf == "rn" && municipio == "parnamirim"){ return cosern }
    if (uf == "rn" && municipio == "passa e fica"){ return cosern }
    if (uf == "rn" && municipio == "passagem"){ return cosern }
    if (uf == "rn" && municipio == "patu"){ return cosern }
    if (uf == "rn" && municipio == "pau dos ferros"){ return cosern }
    if (uf == "rn" && municipio == "pedra grande"){ return cosern }
    if (uf == "rn" && municipio == "pedra preta"){ return cosern }
    if (uf == "rn" && municipio == "pedro avelino"){ return cosern }
    if (uf == "rn" && municipio == "pedro velho"){ return cosern }
    if (uf == "rn" && municipio == "pendencias"){ return cosern }
    if (uf == "rn" && municipio == "piloes"){ return cosern }
    if (uf == "rn" && municipio == "poco branco"){ return cosern }
    if (uf == "rn" && municipio == "portalegre"){ return cosern }
    if (uf == "rn" && municipio == "porto do mangue"){ return cosern }
    if (uf == "rn" && municipio == "pureza"){ return cosern }
    if (uf == "rn" && municipio == "rafael fernandes"){ return cosern }
    if (uf == "rn" && municipio == "rafael godeiro"){ return cosern }
    if (uf == "rn" && municipio == "riacho da cruz"){ return cosern }
    if (uf == "rn" && municipio == "riacho de santana"){ return cosern }
    if (uf == "rn" && municipio == "riachuelo"){ return cosern }
    if (uf == "rn" && municipio == "rio do fogo"){ return cosern }
    if (uf == "rn" && municipio == "rodolfo fernandes"){ return cosern }
    if (uf == "rn" && municipio == "ruy barbosa"){ return cosern }
    if (uf == "rn" && municipio == "santa cruz"){ return cosern }
    if (uf == "rn" && municipio == "santa maria"){ return cosern }
    if (uf == "rn" && municipio == "santana do matos"){ return cosern }
    if (uf == "rn" && municipio == "santana do serido"){ return cosern }
    if (uf == "rn" && municipio == "santo antonio"){ return cosern }
    if (uf == "rn" && municipio == "sao bento do norte"){ return cosern }
    if (uf == "rn" && municipio == "sao bento do trairi"){ return cosern }
    if (uf == "rn" && municipio == "sao fernando"){ return cosern }
    if (uf == "rn" && municipio == "sao francisco do oeste"){ return cosern }
    if (uf == "rn" && municipio == "sao goncalo do amarante"){ return cosern }
    if (uf == "rn" && municipio == "sao joao do sabugi"){ return cosern }
    if (uf == "rn" && municipio == "sao jose de mipibu"){ return cosern }
    if (uf == "rn" && municipio == "sao jose do campestre"){ return cosern }
    if (uf == "rn" && municipio == "sao jose do serido"){ return cosern }
    if (uf == "rn" && municipio == "sao miguel"){ return cosern }
    if (uf == "rn" && municipio == "sao miguel do gostoso"){ return cosern }
    if (uf == "rn" && municipio == "sao paulo do potengi"){ return cosern }
    if (uf == "rn" && municipio == "sao pedro"){ return cosern }
    if (uf == "rn" && municipio == "sao rafael"){ return cosern }
    if (uf == "rn" && municipio == "sao tome"){ return cosern }
    if (uf == "rn" && municipio == "sao vicente"){ return cosern }
    if (uf == "rn" && municipio == "senador eloi de souza"){ return cosern }
    if (uf == "rn" && municipio == "senador georgino avelino"){ return cosern }
    if (uf == "rn" && municipio == "serra caiada"){ return cosern }
    if (uf == "rn" && municipio == "serra de sao bento"){ return cosern }
    if (uf == "rn" && municipio == "serra do mel"){ return cosern }
    if (uf == "rn" && municipio == "serra negra do norte"){ return cosern }
    if (uf == "rn" && municipio == "serrinha"){ return cosern }
    if (uf == "rn" && municipio == "serrinha dos pintos"){ return cosern }
    if (uf == "rn" && municipio == "severiano melo"){ return cosern }
    if (uf == "rn" && municipio == "sitio novo"){ return cosern }
    if (uf == "rn" && municipio == "taboleiro grande"){ return cosern }
    if (uf == "rn" && municipio == "taipu"){ return cosern }
    if (uf == "rn" && municipio == "tangara"){ return cosern }
    if (uf == "rn" && municipio == "tenente ananias"){ return cosern }
    if (uf == "rn" && municipio == "tenente laurentino cruz"){ return cosern }
    if (uf == "rn" && municipio == "tibau"){ return cosern }
    if (uf == "rn" && municipio == "tibau do sul"){ return cosern }
    if (uf == "rn" && municipio == "timbauba dos batistas"){ return cosern }
    if (uf == "rn" && municipio == "touros"){ return cosern }
    if (uf == "rn" && municipio == "triunfo potiguar"){ return cosern }
    if (uf == "rn" && municipio == "umarizal"){ return cosern }
    if (uf == "rn" && municipio == "upanema"){ return cosern }
    if (uf == "rn" && municipio == "varzea"){ return cosern }
    if (uf == "rn" && municipio == "venha-ver"){ return cosern }
    if (uf == "rn" && municipio == "vera cruz"){ return cosern }
    if (uf == "rn" && municipio == "vicosa"){ return cosern }
    if (uf == "rn" && municipio == "vila flor"){ return cosern }
    if (uf == "pe" && municipio == "abreu e lima"){ return celpe }
    if (uf == "pe" && municipio == "afogados da ingazeira"){ return celpe }
    if (uf == "pe" && municipio == "afranio"){ return celpe }
    if (uf == "pe" && municipio == "agrestina"){ return celpe }
    if (uf == "pe" && municipio == "agua preta"){ return celpe }
    if (uf == "pe" && municipio == "aguas belas"){ return celpe }
    if (uf == "pe" && municipio == "alagoinha"){ return celpe }
    if (uf == "pe" && municipio == "alianca"){ return celpe }
    if (uf == "pe" && municipio == "altinho"){ return celpe }
    if (uf == "pe" && municipio == "amaraji"){ return celpe }
    if (uf == "pe" && municipio == "angelim"){ return celpe }
    if (uf == "pe" && municipio == "aracoiaba"){ return celpe }
    if (uf == "pe" && municipio == "araripina"){ return celpe }
    if (uf == "pe" && municipio == "arcoverde"){ return celpe }
    if (uf == "pe" && municipio == "barra de guabiraba"){ return celpe }
    if (uf == "pe" && municipio == "barreiros"){ return celpe }
    if (uf == "pe" && municipio == "belem de maria"){ return celpe }
    if (uf == "pe" && municipio == "belem do sao francisco"){ return celpe }
    if (uf == "pe" && municipio == "belo jardim"){ return celpe }
    if (uf == "pe" && municipio == "betania"){ return celpe }
    if (uf == "pe" && municipio == "bezerros"){ return celpe }
    if (uf == "pe" && municipio == "bodoco"){ return celpe }
    if (uf == "pe" && municipio == "bom conselho"){ return celpe }
    if (uf == "pe" && municipio == "bom jardim"){ return celpe }
    if (uf == "pe" && municipio == "bonito"){ return celpe }
    if (uf == "pe" && municipio == "brejao"){ return celpe }
    if (uf == "pe" && municipio == "brejinho"){ return celpe }
    if (uf == "pe" && municipio == "brejo da madre de deus"){ return celpe }
    if (uf == "pe" && municipio == "buenos aires"){ return celpe }
    if (uf == "pe" && municipio == "buique"){ return celpe }
    if (uf == "pe" && municipio == "cabo de santo agostinho"){ return celpe }
    if (uf == "pe" && municipio == "cabrobo"){ return celpe }
    if (uf == "pe" && municipio == "cachoeirinha"){ return celpe }
    if (uf == "pe" && municipio == "caetes"){ return celpe }
    if (uf == "pe" && municipio == "calcado"){ return celpe }
    if (uf == "pe" && municipio == "calumbi"){ return celpe }
    if (uf == "pe" && municipio == "camaragibe"){ return celpe }
    if (uf == "pe" && municipio == "camocim de sao felix"){ return celpe }
    if (uf == "pe" && municipio == "camutanga"){ return celpe }
    if (uf == "pe" && municipio == "canhotinho"){ return celpe }
    if (uf == "pe" && municipio == "capoeiras"){ return celpe }
    if (uf == "pe" && municipio == "carnaiba"){ return celpe }
    if (uf == "pe" && municipio == "carnaubeira da penha"){ return celpe }
    if (uf == "pe" && municipio == "carpina"){ return celpe }
    if (uf == "pe" && municipio == "caruaru"){ return celpe }
    if (uf == "pe" && municipio == "casinhas"){ return celpe }
    if (uf == "pe" && municipio == "catende"){ return celpe }
    if (uf == "pe" && municipio == "cedro"){ return celpe }
    if (uf == "pe" && municipio == "cha de alegria"){ return celpe }
    if (uf == "pe" && municipio == "cha grande"){ return celpe }
    if (uf == "pe" && municipio == "condado"){ return celpe }
    if (uf == "pe" && municipio == "correntes"){ return celpe }
    if (uf == "pe" && municipio == "cortes"){ return celpe }
    if (uf == "pe" && municipio == "cumaru"){ return celpe }
    if (uf == "pe" && municipio == "cupira"){ return celpe }
    if (uf == "pe" && municipio == "custodia"){ return celpe }
    if (uf == "pe" && municipio == "dormentes"){ return celpe }
    if (uf == "pe" && municipio == "escada"){ return celpe }
    if (uf == "pe" && municipio == "exu"){ return celpe }
    if (uf == "pe" && municipio == "feira nova"){ return celpe }
    if (uf == "pe" && municipio == "fernando de noronha"){ return celpe }
    if (uf == "pe" && municipio == "ferreiros"){ return celpe }
    if (uf == "pe" && municipio == "flores"){ return celpe }
    if (uf == "pe" && municipio == "floresta"){ return celpe }
    if (uf == "pe" && municipio == "frei miguelinho"){ return celpe }
    if (uf == "pe" && municipio == "gameleira"){ return celpe }
    if (uf == "pe" && municipio == "garanhuns"){ return celpe }
    if (uf == "pe" && municipio == "gloria do goita"){ return celpe }
    if (uf == "pe" && municipio == "goiana"){ return celpe }
    if (uf == "pe" && municipio == "granito"){ return celpe }
    if (uf == "pe" && municipio == "gravata"){ return celpe }
    if (uf == "pe" && municipio == "iati"){ return celpe }
    if (uf == "pe" && municipio == "ibimirim"){ return celpe }
    if (uf == "pe" && municipio == "ibirajuba"){ return celpe }
    if (uf == "pe" && municipio == "igarassu"){ return celpe }
    if (uf == "pe" && municipio == "iguaracy"){ return celpe }
    if (uf == "pe" && municipio == "ilha de itamaraca"){ return celpe }
    if (uf == "pe" && municipio == "inaja"){ return celpe }
    if (uf == "pe" && municipio == "ingazeira"){ return celpe }
    if (uf == "pe" && municipio == "ipojuca"){ return celpe }
    if (uf == "pe" && municipio == "ipubi"){ return celpe }
    if (uf == "pe" && municipio == "itacuruba"){ return celpe }
    if (uf == "pe" && municipio == "itaiba"){ return celpe }
    if (uf == "pe" && municipio == "itambe"){ return celpe }
    if (uf == "pe" && municipio == "itapetim"){ return celpe }
    if (uf == "pe" && municipio == "itapissuma"){ return celpe }
    if (uf == "pe" && municipio == "itaquitinga"){ return celpe }
    if (uf == "pe" && municipio == "jaboatao dos guararapes"){ return celpe }
    if (uf == "pe" && municipio == "jaqueira"){ return celpe }
    if (uf == "pe" && municipio == "jatauba"){ return celpe }
    if (uf == "pe" && municipio == "jatoba"){ return celpe }
    if (uf == "pe" && municipio == "joao alfredo"){ return celpe }
    if (uf == "pe" && municipio == "joaquim nabuco"){ return celpe }
    if (uf == "pe" && municipio == "jucati"){ return celpe }
    if (uf == "pe" && municipio == "jupi"){ return celpe }
    if (uf == "pe" && municipio == "jurema"){ return celpe }
    if (uf == "pe" && municipio == "lagoa de itaenga"){ return celpe }
    if (uf == "pe" && municipio == "lagoa do carro"){ return celpe }
    if (uf == "pe" && municipio == "lagoa do ouro"){ return celpe }
    if (uf == "pe" && municipio == "lagoa dos gatos"){ return celpe }
    if (uf == "pe" && municipio == "lagoa grande"){ return celpe }
    if (uf == "pe" && municipio == "lajedo"){ return celpe }
    if (uf == "pe" && municipio == "limoeiro"){ return celpe }
    if (uf == "pe" && municipio == "macaparana"){ return celpe }
    if (uf == "pe" && municipio == "machados"){ return celpe }
    if (uf == "pe" && municipio == "manari"){ return celpe }
    if (uf == "pe" && municipio == "maraial"){ return celpe }
    if (uf == "pe" && municipio == "mirandiba"){ return celpe }
    if (uf == "pe" && municipio == "moreilandia"){ return celpe }
    if (uf == "pe" && municipio == "moreno"){ return celpe }
    if (uf == "pe" && municipio == "nazare da mata"){ return celpe }
    if (uf == "pe" && municipio == "olinda"){ return celpe }
    if (uf == "pe" && municipio == "orobo"){ return celpe }
    if (uf == "pe" && municipio == "oroco"){ return celpe }
    if (uf == "pe" && municipio == "ouricuri"){ return celpe }
    if (uf == "pe" && municipio == "palmares"){ return celpe }
    if (uf == "pe" && municipio == "palmeirina"){ return celpe }
    if (uf == "pe" && municipio == "panelas"){ return celpe }
    if (uf == "pe" && municipio == "paranatama"){ return celpe }
    if (uf == "pe" && municipio == "parnamirim"){ return celpe }
    if (uf == "pe" && municipio == "passira"){ return celpe }
    if (uf == "pe" && municipio == "paudalho"){ return celpe }
    if (uf == "pe" && municipio == "paulista"){ return celpe }
    if (uf == "pe" && municipio == "pedra"){ return celpe }
    if (uf == "pe" && municipio == "pesqueira"){ return celpe }
    if (uf == "pe" && municipio == "petrolandia"){ return celpe }
    if (uf == "pe" && municipio == "petrolina"){ return celpe }
    if (uf == "pe" && municipio == "pocao"){ return celpe }
    if (uf == "pe" && municipio == "pombos"){ return celpe }
    if (uf == "pe" && municipio == "primavera"){ return celpe }
    if (uf == "pe" && municipio == "quipapa"){ return celpe }
    if (uf == "pe" && municipio == "quixaba"){ return celpe }
    if (uf == "pe" && municipio == "recife"){ return celpe }
    if (uf == "pe" && municipio == "riacho das almas"){ return celpe }
    if (uf == "pe" && municipio == "ribeirao"){ return celpe }
    if (uf == "pe" && municipio == "rio formoso"){ return celpe }
    if (uf == "pe" && municipio == "saire"){ return celpe }
    if (uf == "pe" && municipio == "salgadinho"){ return celpe }
    if (uf == "pe" && municipio == "salgueiro"){ return celpe }
    if (uf == "pe" && municipio == "saloa"){ return celpe }
    if (uf == "pe" && municipio == "sanharo"){ return celpe }
    if (uf == "pe" && municipio == "santa cruz"){ return celpe }
    if (uf == "pe" && municipio == "santa cruz da baixa verde"){ return celpe }
    if (uf == "pe" && municipio == "santa cruz do capibaribe"){ return celpe }
    if (uf == "pe" && municipio == "santa filomena"){ return celpe }
    if (uf == "pe" && municipio == "santa maria da boa vista"){ return celpe }
    if (uf == "pe" && municipio == "santa maria do cambuca"){ return celpe }
    if (uf == "pe" && municipio == "santa terezinha"){ return celpe }
    if (uf == "pe" && municipio == "sao benedito do sul"){ return celpe }
    if (uf == "pe" && municipio == "sao bento do una"){ return celpe }
    if (uf == "pe" && municipio == "sao caitano"){ return celpe }
    if (uf == "pe" && municipio == "sao joao"){ return celpe }
    if (uf == "pe" && municipio == "sao joaquim do monte"){ return celpe }
    if (uf == "pe" && municipio == "sao jose da coroa grande"){ return celpe }
    if (uf == "pe" && municipio == "sao jose do belmonte"){ return celpe }
    if (uf == "pe" && municipio == "sao jose do egito"){ return celpe }
    if (uf == "pe" && municipio == "sao lourenco da mata"){ return celpe }
    if (uf == "pe" && municipio == "sao vicente ferrer"){ return celpe }
    if (uf == "pe" && municipio == "serra talhada"){ return celpe }
    if (uf == "pe" && municipio == "serrita"){ return celpe }
    if (uf == "pe" && municipio == "sertania"){ return celpe }
    if (uf == "pe" && municipio == "sirinhaem"){ return celpe }
    if (uf == "pe" && municipio == "solidao"){ return celpe }
    if (uf == "pe" && municipio == "surubim"){ return celpe }
    if (uf == "pe" && municipio == "tabira"){ return celpe }
    if (uf == "pe" && municipio == "tacaimbo"){ return celpe }
    if (uf == "pe" && municipio == "tacaratu"){ return celpe }
    if (uf == "pe" && municipio == "tamandare"){ return celpe }
    if (uf == "pe" && municipio == "taquaritinga do norte"){ return celpe }
    if (uf == "pe" && municipio == "terezinha"){ return celpe }
    if (uf == "pe" && municipio == "terra nova"){ return celpe }
    if (uf == "pe" && municipio == "timbauba"){ return celpe }
    if (uf == "pe" && municipio == "toritama"){ return celpe }
    if (uf == "pe" && municipio == "tracunhaem"){ return celpe }
    if (uf == "pe" && municipio == "trindade"){ return celpe }
    if (uf == "pe" && municipio == "triunfo"){ return celpe }
    if (uf == "pe" && municipio == "tupanatinga"){ return celpe }
    if (uf == "pe" && municipio == "tuparetama"){ return celpe }
    if (uf == "pe" && municipio == "venturosa"){ return celpe }
    if (uf == "pe" && municipio == "verdejante"){ return celpe }
    if (uf == "pe" && municipio == "vertente do lerio"){ return celpe }
    if (uf == "pe" && municipio == "vertentes"){ return celpe }
    if (uf == "pe" && municipio == "vicencia"){ return celpe }
    if (uf == "pe" && municipio == "vitoria de santo antao"){ return celpe }
    if (uf == "pe" && municipio == "xexeu"){ return celpe }

    // return `imagem não encontrada: ${uf} - ${municipio}`
    return "sem_imagem"
}
